/**
 * Generated by orval 🍺
 * Do not edit manually.
 * knowledge-backend
 * OpenAPI spec version: 0.1.0
 */
import type {
  ActiveRulesRequest,
  ActiveRulesResponse,
  AgentConfigurationResponse,
  AgentConfigurationUpdateRequest,
  AgentsListProvidersParams,
  BatchAddCommentsRequest,
  BatchAddEvaluationsRequest,
  BatchAnchorIngestRequest,
  BatchCreateRequest,
  BatchDetailResponse,
  BatchFailRequest,
  BatchListResponse,
  BatchProposalsRequest,
  BatchResponse,
  CheckSenderWhitelistParams,
  CommentCreateRequest,
  CommentListResponse,
  CommentResponse,
  CommentUpdateRequest,
  CommentsListCommentsParams,
  CompactInstructionRequest,
  ConversationViewCreateRequest,
  ConversationViewResponse,
  ConversationViewUpdateRequest,
  EnvironmentSnapshotsListEnvironmentSnapshotsParams,
  EvaluationCreateRequest,
  EvaluationListResponse,
  EvaluationResponse,
  EvaluationsListEvaluationsParams,
  FeedbackBatchesAddCommentsToBatch200,
  FeedbackBatchesAddEvaluationsToBatch200,
  FeedbackBatchesArchiveFeedbackBatch200,
  FeedbackBatchesFailFeedbackBatch200,
  FeedbackBatchesListFeedbackBatchesParams,
  FeedbackBatchesPersistBatchProposals200,
  FeedbackBatchesProcessFeedbackBatch202,
  FeedbackBatchesPromoteFeedbackBatch200,
  FeedbackBatchesRejectFeedbackBatch200,
  FeedbackBatchesRemoveCommentFromBatch200,
  FeedbackBatchesRemoveEvaluationFromBatch200,
  FeedbackBatchesReopenFeedbackBatch200,
  GetGoogleIntegrationParams,
  GetXeroIntegrationParams,
  GoogleIntegrationDetailResponse,
  GoogleIntegrationResponse,
  GoogleIntegrationUpsertRequest,
  GoogleStatusUpdateRequest,
  GoogleTokenUpdateRequest,
  GoogleTokenUpdateResponse,
  GoogleWatchUpdateRequest,
  GoogleWatchUpdateResponse,
  GuardrailItemCreateRequest,
  GuardrailItemDetailResponse,
  GuardrailItemResponse,
  GuardrailItemUpdateRequest,
  GuardrailValidateRequest,
  GuardrailValidateResponse,
  GuardrailsListItemsParams,
  HTTPValidationError,
  HealthResponse,
  KnowledgeChunkDetailResponse,
  KnowledgeChunkResponse,
  KnowledgeItemCreateRequest,
  KnowledgeItemListResponse,
  KnowledgeItemResponse,
  KnowledgeItemUpdateRequest,
  KnowledgeListKnowledgeItemsParams,
  KnowledgeSearchRequest,
  KnowledgeSearchResponse,
  MessageCreateRequest,
  MessageResponse,
  MessageUpdateRequest,
  MessagesGetMessagesParams,
  MessagesListResponse,
  ModelCatalogResponse,
  ProcessedMessageCreateRequest,
  ProcessedMessageResponse,
  PropelAuthSyncSummary,
  ProviderCatalogResponse,
  RollbackRequest,
  RuleActivateRequest,
  RuleCompactProposalResponse,
  RuleCompactRequest,
  RuleDraftRequest,
  RuleListResponse,
  RuleResponse,
  RuleRevertRequest,
  RuleSupersedeRequest,
  RuleUpdateRequest,
  RulesListRulesParams,
  RunCreateRequest,
  RunEventCreateRequest,
  RunEventResponse,
  RunListResponse,
  RunResponse,
  RunUpdateRequest,
  RunsGetRunsSummaryParams,
  RunsListRunsParams,
  RunsSummaryResponse,
  SimulationRequest,
  SimulationResponse,
  SnapshotCreateRequest,
  SnapshotListResponse,
  SnapshotResponse,
  StatusResponse,
  TestCaseCreateRequest,
  TestCaseResponse,
  TestCaseSuggestRequest,
  TestCaseSuggestResponse,
  TestCaseSuggestTitleRequest,
  TestCaseSuggestTitleResponse,
  TestCaseUpdateRequest,
  TestRunComparisonResponse,
  TestRunCreateRequest,
  TestRunListResponse,
  TestRunResponse,
  TestRunUpdateRequest,
  TestRunsCompareTestRunsParams,
  TestRunsListTestRunsParams,
  TestSuiteCloneRequest,
  TestSuiteCreateRequest,
  TestSuiteDetailResponse,
  TestSuiteImportRequest,
  TestSuiteListResponse,
  TestSuiteSummaryResponse,
  TestSuiteUpdateRequest,
  TestSuitesListTestSuitesParams,
  ThreadCreateRequest,
  ThreadListResponse,
  ThreadResponse,
  ThreadScorecardResponse,
  ThreadUpdateRequest,
  ThreadsListThreadsParams,
  User,
  UserCreateRequest,
  UserListResponse,
  UserResponse,
  UserUpdateRequest,
  UsersListUsersParams,
  WebhookResponse,
  WhitelistCheckResponse,
  XeroIntegrationDetailResponse,
  XeroIntegrationResponse,
  XeroIntegrationUpsertRequest
} from './models';

import { customFetch } from '../config/custom-fetch';

export type authGetStatusResponse200 = {
  data: StatusResponse
  status: 200
}

export type authGetStatusResponseSuccess = (authGetStatusResponse200) & {
  headers: Headers;
};
;

export type authGetStatusResponse = (authGetStatusResponseSuccess)

export const getAuthGetStatusUrl = () => {




  return `/api/v1/status`
}

/**
 * Diagnostic endpoint returning service metadata and authentication service URL.
 * @summary Get Status
 */
export const authGetStatus = async ( options?: Parameters<typeof customFetch>[1]): Promise<authGetStatusResponse> => {

  return customFetch<authGetStatusResponse>(getAuthGetStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type authGetMeResponse200 = {
  data: User
  status: 200
}

export type authGetMeResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type authGetMeResponseSuccess = (authGetMeResponse200) & {
  headers: Headers;
};
export type authGetMeResponseError = (authGetMeResponse422) & {
  headers: Headers;
};

export type authGetMeResponse = (authGetMeResponseSuccess | authGetMeResponseError)

export const getAuthGetMeUrl = () => {




  return `/api/v1/me`
}

/**
 * Returns current authenticated user identity, active role, active org_id, and accessible organizations.
 * @summary Get Me
 */
export const authGetMe = async ( options?: Parameters<typeof customFetch>[1]): Promise<authGetMeResponse> => {

  return customFetch<authGetMeResponse>(getAuthGetMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type usersListUsersResponse200 = {
  data: UserListResponse
  status: 200
}

export type usersListUsersResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type usersListUsersResponseSuccess = (usersListUsersResponse200) & {
  headers: Headers;
};
export type usersListUsersResponseError = (usersListUsersResponse422) & {
  headers: Headers;
};

export type usersListUsersResponse = (usersListUsersResponseSuccess | usersListUsersResponseError)

export const getUsersListUsersUrl = (params?: UsersListUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/users?${stringifiedParams}` : `/api/v1/users`
}

/**
 * List registered users and agent identities with filtering, searching, and pagination.
 * @summary List Users
 */
export const usersListUsers = async (params?: UsersListUsersParams, options?: Parameters<typeof customFetch>[1]): Promise<usersListUsersResponse> => {

  return customFetch<usersListUsersResponse>(getUsersListUsersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type usersCreateUserResponse201 = {
  data: UserResponse
  status: 201
}

export type usersCreateUserResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type usersCreateUserResponseSuccess = (usersCreateUserResponse201) & {
  headers: Headers;
};
export type usersCreateUserResponseError = (usersCreateUserResponse422) & {
  headers: Headers;
};

export type usersCreateUserResponse = (usersCreateUserResponseSuccess | usersCreateUserResponseError)

export const getUsersCreateUserUrl = () => {




  return `/api/v1/users`
}

/**
 * Provision a local user or agent identity.
 * @summary Create User
 */
export const usersCreateUser = async (userCreateRequest: UserCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<usersCreateUserResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<usersCreateUserResponse>(getUsersCreateUserUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(userCreateRequest)
  }
);}



export type usersGetUserResponse200 = {
  data: UserResponse
  status: 200
}

export type usersGetUserResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type usersGetUserResponseSuccess = (usersGetUserResponse200) & {
  headers: Headers;
};
export type usersGetUserResponseError = (usersGetUserResponse422) & {
  headers: Headers;
};

export type usersGetUserResponse = (usersGetUserResponseSuccess | usersGetUserResponseError)

export const getUsersGetUserUrl = (userId: string,) => {




  return `/api/v1/users/${userId}`
}

/**
 * Fetch a specific user or agent identity by user_id.
 * @summary Get User
 */
export const usersGetUser = async (userId: string, options?: Parameters<typeof customFetch>[1]): Promise<usersGetUserResponse> => {

  return customFetch<usersGetUserResponse>(getUsersGetUserUrl(userId),
  {
    ...options,
    method: 'GET'


  }
);}



export type usersUpdateUserResponse200 = {
  data: UserResponse
  status: 200
}

export type usersUpdateUserResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type usersUpdateUserResponseSuccess = (usersUpdateUserResponse200) & {
  headers: Headers;
};
export type usersUpdateUserResponseError = (usersUpdateUserResponse422) & {
  headers: Headers;
};

export type usersUpdateUserResponse = (usersUpdateUserResponseSuccess | usersUpdateUserResponseError)

export const getUsersUpdateUserUrl = (userId: string,) => {




  return `/api/v1/users/${userId}`
}

/**
 * Update user names, display name, agent designation, or agent type.
 * Note: Email and user_id are immutable and cannot be updated.
 * @summary Update User
 */
export const usersUpdateUser = async (userId: string,
    userUpdateRequest: UserUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<usersUpdateUserResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<usersUpdateUserResponse>(getUsersUpdateUserUrl(userId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(userUpdateRequest)
  }
);}



export type usersSyncAllPropelauthResponse200 = {
  data: PropelAuthSyncSummary
  status: 200
}

export type usersSyncAllPropelauthResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type usersSyncAllPropelauthResponseSuccess = (usersSyncAllPropelauthResponse200) & {
  headers: Headers;
};
export type usersSyncAllPropelauthResponseError = (usersSyncAllPropelauthResponse422) & {
  headers: Headers;
};

export type usersSyncAllPropelauthResponse = (usersSyncAllPropelauthResponseSuccess | usersSyncAllPropelauthResponseError)

export const getUsersSyncAllPropelauthUrl = () => {




  return `/api/v1/users/sync-propelauth`
}

/**
 * Sync all user profiles from PropelAuth into the local platform users table.
 * @summary Sync All Propelauth
 */
export const usersSyncAllPropelauth = async ( options?: Parameters<typeof customFetch>[1]): Promise<usersSyncAllPropelauthResponse> => {

  return customFetch<usersSyncAllPropelauthResponse>(getUsersSyncAllPropelauthUrl(),
  {
    ...options,
    method: 'POST'


  }
);}



export type usersSyncSingleUserResponse200 = {
  data: UserResponse
  status: 200
}

export type usersSyncSingleUserResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type usersSyncSingleUserResponseSuccess = (usersSyncSingleUserResponse200) & {
  headers: Headers;
};
export type usersSyncSingleUserResponseError = (usersSyncSingleUserResponse422) & {
  headers: Headers;
};

export type usersSyncSingleUserResponse = (usersSyncSingleUserResponseSuccess | usersSyncSingleUserResponseError)

export const getUsersSyncSingleUserUrl = (userId: string,) => {




  return `/api/v1/users/${userId}/sync`
}

/**
 * Fetch the latest profile for a single user from PropelAuth and update local database.
 * @summary Sync Single User
 */
export const usersSyncSingleUser = async (userId: string, options?: Parameters<typeof customFetch>[1]): Promise<usersSyncSingleUserResponse> => {

  return customFetch<usersSyncSingleUserResponse>(getUsersSyncSingleUserUrl(userId),
  {
    ...options,
    method: 'POST'


  }
);}



export type webhooksHandlePropelauthWebhookResponse200 = {
  data: WebhookResponse
  status: 200
}

export type webhooksHandlePropelauthWebhookResponseSuccess = (webhooksHandlePropelauthWebhookResponse200) & {
  headers: Headers;
};
;

export type webhooksHandlePropelauthWebhookResponse = (webhooksHandlePropelauthWebhookResponseSuccess)

export const getWebhooksHandlePropelauthWebhookUrl = () => {




  return `/api/v1/webhooks/propelauth`
}

/**
 * Webhook ingress endpoint for PropelAuth lifecycle events (user, org, and role events).
 * Authenticates requests via Svix HMAC-SHA256 signatures with replay protection.
 * @summary Handle Propelauth Webhook
 */
export const webhooksHandlePropelauthWebhook = async ( options?: Parameters<typeof customFetch>[1]): Promise<webhooksHandlePropelauthWebhookResponse> => {

  return customFetch<webhooksHandlePropelauthWebhookResponse>(getWebhooksHandlePropelauthWebhookUrl(),
  {
    ...options,
    method: 'POST'


  }
);}



export type threadsGetOrCreateThreadResponse200 = {
  data: ThreadResponse
  status: 200
}

export type threadsGetOrCreateThreadResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type threadsGetOrCreateThreadResponseSuccess = (threadsGetOrCreateThreadResponse200) & {
  headers: Headers;
};
export type threadsGetOrCreateThreadResponseError = (threadsGetOrCreateThreadResponse422) & {
  headers: Headers;
};

export type threadsGetOrCreateThreadResponse = (threadsGetOrCreateThreadResponseSuccess | threadsGetOrCreateThreadResponseError)

export const getThreadsGetOrCreateThreadUrl = () => {




  return `/api/v1/threads`
}

/**
 * Idempotently retrieves an existing thread matching source coordinates,
 * or creates a new thread bound to the caller's organization.
 * @summary Get Or Create Thread
 */
export const threadsGetOrCreateThread = async (threadCreateRequest: ThreadCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<threadsGetOrCreateThreadResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<threadsGetOrCreateThreadResponse>(getThreadsGetOrCreateThreadUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(threadCreateRequest)
  }
);}



export type threadsListThreadsResponse200 = {
  data: ThreadListResponse
  status: 200
}

export type threadsListThreadsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type threadsListThreadsResponseSuccess = (threadsListThreadsResponse200) & {
  headers: Headers;
};
export type threadsListThreadsResponseError = (threadsListThreadsResponse422) & {
  headers: Headers;
};

export type threadsListThreadsResponse = (threadsListThreadsResponseSuccess | threadsListThreadsResponseError)

export const getThreadsListThreadsUrl = (params?: ThreadsListThreadsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/threads?${stringifiedParams}` : `/api/v1/threads`
}

/**
 * Lists conversational threads scoped strictly to user organization.
 * Supports server-side search (q), quick score/review filtering, and pagination.
 * @summary List Threads
 */
export const threadsListThreads = async (params?: ThreadsListThreadsParams, options?: Parameters<typeof customFetch>[1]): Promise<threadsListThreadsResponse> => {

  return customFetch<threadsListThreadsResponse>(getThreadsListThreadsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type threadsUpdateThreadResponse200 = {
  data: ThreadResponse
  status: 200
}

export type threadsUpdateThreadResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type threadsUpdateThreadResponseSuccess = (threadsUpdateThreadResponse200) & {
  headers: Headers;
};
export type threadsUpdateThreadResponseError = (threadsUpdateThreadResponse422) & {
  headers: Headers;
};

export type threadsUpdateThreadResponse = (threadsUpdateThreadResponseSuccess | threadsUpdateThreadResponseError)

export const getThreadsUpdateThreadUrl = (threadId: string,) => {




  return `/api/v1/threads/${threadId}`
}

/**
 * Updates completion status, presentation targets, or metadata of an existing thread.
 * @summary Update Thread
 */
export const threadsUpdateThread = async (threadId: string,
    threadUpdateRequest: ThreadUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<threadsUpdateThreadResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<threadsUpdateThreadResponse>(getThreadsUpdateThreadUrl(threadId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(threadUpdateRequest)
  }
);}



export type threadsGetThreadResponse200 = {
  data: ThreadResponse
  status: 200
}

export type threadsGetThreadResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type threadsGetThreadResponseSuccess = (threadsGetThreadResponse200) & {
  headers: Headers;
};
export type threadsGetThreadResponseError = (threadsGetThreadResponse422) & {
  headers: Headers;
};

export type threadsGetThreadResponse = (threadsGetThreadResponseSuccess | threadsGetThreadResponseError)

export const getThreadsGetThreadUrl = (threadId: string,) => {




  return `/api/v1/threads/${threadId}`
}

/**
 * Retrieves full details for a thread record scoped to caller's organization.
 * @summary Get Thread
 */
export const threadsGetThread = async (threadId: string, options?: Parameters<typeof customFetch>[1]): Promise<threadsGetThreadResponse> => {

  return customFetch<threadsGetThreadResponse>(getThreadsGetThreadUrl(threadId),
  {
    ...options,
    method: 'GET'


  }
);}



export type runsCreateRunResponse201 = {
  data: RunResponse
  status: 201
}

export type runsCreateRunResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type runsCreateRunResponseSuccess = (runsCreateRunResponse201) & {
  headers: Headers;
};
export type runsCreateRunResponseError = (runsCreateRunResponse422) & {
  headers: Headers;
};

export type runsCreateRunResponse = (runsCreateRunResponseSuccess | runsCreateRunResponseError)

export const getRunsCreateRunUrl = () => {




  return `/api/v1/runs`
}

/**
 * Creates an execution run bound to thread or feedback batch and current organization.
 * @summary Create Run
 */
export const runsCreateRun = async (runCreateRequest: RunCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<runsCreateRunResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<runsCreateRunResponse>(getRunsCreateRunUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(runCreateRequest)
  }
);}



export type runsListRunsResponse200 = {
  data: RunListResponse
  status: 200
}

export type runsListRunsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type runsListRunsResponseSuccess = (runsListRunsResponse200) & {
  headers: Headers;
};
export type runsListRunsResponseError = (runsListRunsResponse422) & {
  headers: Headers;
};

export type runsListRunsResponse = (runsListRunsResponseSuccess | runsListRunsResponseError)

export const getRunsListRunsUrl = (params?: RunsListRunsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/runs?${stringifiedParams}` : `/api/v1/runs`
}

/**
 * Lists execution runs scoped to current organization.
 * Supports server-side search (q), temporal bounds, and pagination.
 * @summary List Runs
 */
export const runsListRuns = async (params?: RunsListRunsParams, options?: Parameters<typeof customFetch>[1]): Promise<runsListRunsResponse> => {

  return customFetch<runsListRunsResponse>(getRunsListRunsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type runsUpdateRunResponse200 = {
  data: RunResponse
  status: 200
}

export type runsUpdateRunResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type runsUpdateRunResponseSuccess = (runsUpdateRunResponse200) & {
  headers: Headers;
};
export type runsUpdateRunResponseError = (runsUpdateRunResponse422) & {
  headers: Headers;
};

export type runsUpdateRunResponse = (runsUpdateRunResponseSuccess | runsUpdateRunResponseError)

export const getRunsUpdateRunUrl = (runId: string,) => {




  return `/api/v1/runs/${runId}`
}

/**
 * Updates execution run status, state, result payload, and telemetry metrics.
 * @summary Update Run
 */
export const runsUpdateRun = async (runId: string,
    runUpdateRequest: RunUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<runsUpdateRunResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<runsUpdateRunResponse>(getRunsUpdateRunUrl(runId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(runUpdateRequest)
  }
);}



export type runsGetRunResponse200 = {
  data: RunResponse
  status: 200
}

export type runsGetRunResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type runsGetRunResponseSuccess = (runsGetRunResponse200) & {
  headers: Headers;
};
export type runsGetRunResponseError = (runsGetRunResponse422) & {
  headers: Headers;
};

export type runsGetRunResponse = (runsGetRunResponseSuccess | runsGetRunResponseError)

export const getRunsGetRunUrl = (runId: string,) => {




  return `/api/v1/runs/${runId}`
}

/**
 * Retrieves full execution run details scoped to current organization.
 * @summary Get Run
 */
export const runsGetRun = async (runId: string, options?: Parameters<typeof customFetch>[1]): Promise<runsGetRunResponse> => {

  return customFetch<runsGetRunResponse>(getRunsGetRunUrl(runId),
  {
    ...options,
    method: 'GET'


  }
);}



export type runsGetRunsSummaryResponse200 = {
  data: RunsSummaryResponse
  status: 200
}

export type runsGetRunsSummaryResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type runsGetRunsSummaryResponseSuccess = (runsGetRunsSummaryResponse200) & {
  headers: Headers;
};
export type runsGetRunsSummaryResponseError = (runsGetRunsSummaryResponse422) & {
  headers: Headers;
};

export type runsGetRunsSummaryResponse = (runsGetRunsSummaryResponseSuccess | runsGetRunsSummaryResponseError)

export const getRunsGetRunsSummaryUrl = (params?: RunsGetRunsSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/runs/summary?${stringifiedParams}` : `/api/v1/runs/summary`
}

/**
 * Computes aggregate telemetry metrics across the entire filtered runs dataset.
 * @summary Get Runs Summary
 */
export const runsGetRunsSummary = async (params?: RunsGetRunsSummaryParams, options?: Parameters<typeof customFetch>[1]): Promise<runsGetRunsSummaryResponse> => {

  return customFetch<runsGetRunsSummaryResponse>(getRunsGetRunsSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type runsAppendRunEventResponse201 = {
  data: RunEventResponse
  status: 201
}

export type runsAppendRunEventResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type runsAppendRunEventResponseSuccess = (runsAppendRunEventResponse201) & {
  headers: Headers;
};
export type runsAppendRunEventResponseError = (runsAppendRunEventResponse422) & {
  headers: Headers;
};

export type runsAppendRunEventResponse = (runsAppendRunEventResponseSuccess | runsAppendRunEventResponseError)

export const getRunsAppendRunEventUrl = (runId: string,) => {




  return `/api/v1/runs/${runId}/events`
}

/**
 * Appends a sequential step event to a run trace.
 * @summary Append Run Event
 */
export const runsAppendRunEvent = async (runId: string,
    runEventCreateRequest: RunEventCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<runsAppendRunEventResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<runsAppendRunEventResponse>(getRunsAppendRunEventUrl(runId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(runEventCreateRequest)
  }
);}



export type runsGetRunEventsResponse200 = {
  data: RunEventResponse[]
  status: 200
}

export type runsGetRunEventsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type runsGetRunEventsResponseSuccess = (runsGetRunEventsResponse200) & {
  headers: Headers;
};
export type runsGetRunEventsResponseError = (runsGetRunEventsResponse422) & {
  headers: Headers;
};

export type runsGetRunEventsResponse = (runsGetRunEventsResponseSuccess | runsGetRunEventsResponseError)

export const getRunsGetRunEventsUrl = (runId: string,) => {




  return `/api/v1/runs/${runId}/events`
}

/**
 * Retrieves sequential trace events for a given run ordered by step number.
 * @summary Get Run Events
 */
export const runsGetRunEvents = async (runId: string, options?: Parameters<typeof customFetch>[1]): Promise<runsGetRunEventsResponse> => {

  return customFetch<runsGetRunEventsResponse>(getRunsGetRunEventsUrl(runId),
  {
    ...options,
    method: 'GET'


  }
);}



export type messagesAppendMessageResponse201 = {
  data: MessageResponse
  status: 201
}

export type messagesAppendMessageResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type messagesAppendMessageResponseSuccess = (messagesAppendMessageResponse201) & {
  headers: Headers;
};
export type messagesAppendMessageResponseError = (messagesAppendMessageResponse422) & {
  headers: Headers;
};

export type messagesAppendMessageResponse = (messagesAppendMessageResponseSuccess | messagesAppendMessageResponseError)

export const getMessagesAppendMessageUrl = (threadId: string,) => {




  return `/api/v1/threads/${threadId}/messages`
}

/**
 * Appends a conversational turn message to a thread history.
 * @summary Append Message
 */
export const messagesAppendMessage = async (threadId: string,
    messageCreateRequest: MessageCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<messagesAppendMessageResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<messagesAppendMessageResponse>(getMessagesAppendMessageUrl(threadId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(messageCreateRequest)
  }
);}



export type messagesGetMessagesResponse200 = {
  data: MessagesListResponse
  status: 200
}

export type messagesGetMessagesResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type messagesGetMessagesResponseSuccess = (messagesGetMessagesResponse200) & {
  headers: Headers;
};
export type messagesGetMessagesResponseError = (messagesGetMessagesResponse422) & {
  headers: Headers;
};

export type messagesGetMessagesResponse = (messagesGetMessagesResponseSuccess | messagesGetMessagesResponseError)

export const getMessagesGetMessagesUrl = (threadId: string,
    params?: MessagesGetMessagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/threads/${threadId}/messages?${stringifiedParams}` : `/api/v1/threads/${threadId}/messages`
}

/**
 * Retrieves chronological conversation turns for context reconstruction.
 * @summary Get Messages
 */
export const messagesGetMessages = async (threadId: string,
    params?: MessagesGetMessagesParams, options?: Parameters<typeof customFetch>[1]): Promise<messagesGetMessagesResponse> => {

  return customFetch<messagesGetMessagesResponse>(getMessagesGetMessagesUrl(threadId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type messagesGetMessageResponse200 = {
  data: MessageResponse
  status: 200
}

export type messagesGetMessageResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type messagesGetMessageResponseSuccess = (messagesGetMessageResponse200) & {
  headers: Headers;
};
export type messagesGetMessageResponseError = (messagesGetMessageResponse422) & {
  headers: Headers;
};

export type messagesGetMessageResponse = (messagesGetMessageResponseSuccess | messagesGetMessageResponseError)

export const getMessagesGetMessageUrl = (threadId: string,
    messageId: string,) => {




  return `/api/v1/threads/${threadId}/messages/${messageId}`
}

/**
 * Retrieves a single message by ID.
 * @summary Get Message
 */
export const messagesGetMessage = async (threadId: string,
    messageId: string, options?: Parameters<typeof customFetch>[1]): Promise<messagesGetMessageResponse> => {

  return customFetch<messagesGetMessageResponse>(getMessagesGetMessageUrl(threadId,messageId),
  {
    ...options,
    method: 'GET'


  }
);}



export type messagesUpdateMessageResponse200 = {
  data: MessageResponse
  status: 200
}

export type messagesUpdateMessageResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type messagesUpdateMessageResponseSuccess = (messagesUpdateMessageResponse200) & {
  headers: Headers;
};
export type messagesUpdateMessageResponseError = (messagesUpdateMessageResponse422) & {
  headers: Headers;
};

export type messagesUpdateMessageResponse = (messagesUpdateMessageResponseSuccess | messagesUpdateMessageResponseError)

export const getMessagesUpdateMessageUrl = (threadId: string,
    messageId: string,) => {




  return `/api/v1/threads/${threadId}/messages/${messageId}`
}

/**
 * Updates an existing message in-place (e.g. when staff alters & sends or confirms a draft).
 * @summary Update Message
 */
export const messagesUpdateMessage = async (threadId: string,
    messageId: string,
    messageUpdateRequest: MessageUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<messagesUpdateMessageResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<messagesUpdateMessageResponse>(getMessagesUpdateMessageUrl(threadId,messageId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(messageUpdateRequest)
  }
);}



export type messagesUpdateMessageByTsResponse200 = {
  data: MessageResponse
  status: 200
}

export type messagesUpdateMessageByTsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type messagesUpdateMessageByTsResponseSuccess = (messagesUpdateMessageByTsResponse200) & {
  headers: Headers;
};
export type messagesUpdateMessageByTsResponseError = (messagesUpdateMessageByTsResponse422) & {
  headers: Headers;
};

export type messagesUpdateMessageByTsResponse = (messagesUpdateMessageByTsResponseSuccess | messagesUpdateMessageByTsResponseError)

export const getMessagesUpdateMessageByTsUrl = (threadId: string,
    channelMessageTs: string,) => {




  return `/api/v1/threads/${threadId}/messages/by-ts/${channelMessageTs}`
}

/**
 * Updates an existing message in-place identified by channel_message_ts.
 * @summary Update Message By Ts
 */
export const messagesUpdateMessageByTs = async (threadId: string,
    channelMessageTs: string,
    messageUpdateRequest: MessageUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<messagesUpdateMessageByTsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<messagesUpdateMessageByTsResponse>(getMessagesUpdateMessageByTsUrl(threadId,channelMessageTs),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(messageUpdateRequest)
  }
);}



export type evaluationsCreateEvaluationResponse201 = {
  data: EvaluationResponse
  status: 201
}

export type evaluationsCreateEvaluationResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type evaluationsCreateEvaluationResponseSuccess = (evaluationsCreateEvaluationResponse201) & {
  headers: Headers;
};
export type evaluationsCreateEvaluationResponseError = (evaluationsCreateEvaluationResponse422) & {
  headers: Headers;
};

export type evaluationsCreateEvaluationResponse = (evaluationsCreateEvaluationResponseSuccess | evaluationsCreateEvaluationResponseError)

export const getEvaluationsCreateEvaluationUrl = () => {




  return `/api/v1/evaluations`
}

/**
 * Creates a new evaluation record.
 * @summary Create Evaluation
 */
export const evaluationsCreateEvaluation = async (evaluationCreateRequest: EvaluationCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<evaluationsCreateEvaluationResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<evaluationsCreateEvaluationResponse>(getEvaluationsCreateEvaluationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(evaluationCreateRequest)
  }
);}



export type evaluationsListEvaluationsResponse200 = {
  data: EvaluationListResponse
  status: 200
}

export type evaluationsListEvaluationsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type evaluationsListEvaluationsResponseSuccess = (evaluationsListEvaluationsResponse200) & {
  headers: Headers;
};
export type evaluationsListEvaluationsResponseError = (evaluationsListEvaluationsResponse422) & {
  headers: Headers;
};

export type evaluationsListEvaluationsResponse = (evaluationsListEvaluationsResponseSuccess | evaluationsListEvaluationsResponseError)

export const getEvaluationsListEvaluationsUrl = (params?: EvaluationsListEvaluationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/evaluations?${stringifiedParams}` : `/api/v1/evaluations`
}

/**
 * Lists evaluation records scoped to current organization with search and pagination.
 * @summary List Evaluations
 */
export const evaluationsListEvaluations = async (params?: EvaluationsListEvaluationsParams, options?: Parameters<typeof customFetch>[1]): Promise<evaluationsListEvaluationsResponse> => {

  return customFetch<evaluationsListEvaluationsResponse>(getEvaluationsListEvaluationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type evaluationsArchiveEvaluationResponse200 = {
  data: EvaluationResponse
  status: 200
}

export type evaluationsArchiveEvaluationResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type evaluationsArchiveEvaluationResponseSuccess = (evaluationsArchiveEvaluationResponse200) & {
  headers: Headers;
};
export type evaluationsArchiveEvaluationResponseError = (evaluationsArchiveEvaluationResponse422) & {
  headers: Headers;
};

export type evaluationsArchiveEvaluationResponse = (evaluationsArchiveEvaluationResponseSuccess | evaluationsArchiveEvaluationResponseError)

export const getEvaluationsArchiveEvaluationUrl = (evaluationId: string,) => {




  return `/api/v1/evaluations/${evaluationId}/archive`
}

/**
 * Archives a human evaluation so it no longer impacts thread scorecard.
 * @summary Archive Evaluation
 */
export const evaluationsArchiveEvaluation = async (evaluationId: string, options?: Parameters<typeof customFetch>[1]): Promise<evaluationsArchiveEvaluationResponse> => {

  return customFetch<evaluationsArchiveEvaluationResponse>(getEvaluationsArchiveEvaluationUrl(evaluationId),
  {
    ...options,
    method: 'POST'


  }
);}



export type evaluationsGetThreadScorecardResponse200 = {
  data: ThreadScorecardResponse
  status: 200
}

export type evaluationsGetThreadScorecardResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type evaluationsGetThreadScorecardResponseSuccess = (evaluationsGetThreadScorecardResponse200) & {
  headers: Headers;
};
export type evaluationsGetThreadScorecardResponseError = (evaluationsGetThreadScorecardResponse422) & {
  headers: Headers;
};

export type evaluationsGetThreadScorecardResponse = (evaluationsGetThreadScorecardResponseSuccess | evaluationsGetThreadScorecardResponseError)

export const getEvaluationsGetThreadScorecardUrl = (threadId: string,) => {




  return `/api/v1/evaluations/threads/${threadId}/scorecard`
}

/**
 * Computes composite thread scorecard synthesizing multi-evaluator assessments:
 * - 70% human weight + 30% automated weight when both exist.
 * - 100% automated weight if only automated evaluations exist.
 * - Flagged if aggregate_score < 3.50, hallucination_detected is true, or any human flagged.
 * @summary Get Thread Scorecard
 */
export const evaluationsGetThreadScorecard = async (threadId: string, options?: Parameters<typeof customFetch>[1]): Promise<evaluationsGetThreadScorecardResponse> => {

  return customFetch<evaluationsGetThreadScorecardResponse>(getEvaluationsGetThreadScorecardUrl(threadId),
  {
    ...options,
    method: 'GET'


  }
);}



export type commentsListCommentsResponse200 = {
  data: CommentListResponse
  status: 200
}

export type commentsListCommentsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type commentsListCommentsResponseSuccess = (commentsListCommentsResponse200) & {
  headers: Headers;
};
export type commentsListCommentsResponseError = (commentsListCommentsResponse422) & {
  headers: Headers;
};

export type commentsListCommentsResponse = (commentsListCommentsResponseSuccess | commentsListCommentsResponseError)

export const getCommentsListCommentsUrl = (params?: CommentsListCommentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/comments?${stringifiedParams}` : `/api/v1/comments`
}

/**
 * @summary List Comments
 */
export const commentsListComments = async (params?: CommentsListCommentsParams, options?: Parameters<typeof customFetch>[1]): Promise<commentsListCommentsResponse> => {

  return customFetch<commentsListCommentsResponse>(getCommentsListCommentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type commentsCreateCommentResponse201 = {
  data: CommentResponse
  status: 201
}

export type commentsCreateCommentResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type commentsCreateCommentResponseSuccess = (commentsCreateCommentResponse201) & {
  headers: Headers;
};
export type commentsCreateCommentResponseError = (commentsCreateCommentResponse422) & {
  headers: Headers;
};

export type commentsCreateCommentResponse = (commentsCreateCommentResponseSuccess | commentsCreateCommentResponseError)

export const getCommentsCreateCommentUrl = () => {




  return `/api/v1/comments`
}

/**
 * @summary Create Comment
 */
export const commentsCreateComment = async (commentCreateRequest: CommentCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<commentsCreateCommentResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<commentsCreateCommentResponse>(getCommentsCreateCommentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(commentCreateRequest)
  }
);}



export type commentsGetCommentResponse200 = {
  data: CommentResponse
  status: 200
}

export type commentsGetCommentResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type commentsGetCommentResponseSuccess = (commentsGetCommentResponse200) & {
  headers: Headers;
};
export type commentsGetCommentResponseError = (commentsGetCommentResponse422) & {
  headers: Headers;
};

export type commentsGetCommentResponse = (commentsGetCommentResponseSuccess | commentsGetCommentResponseError)

export const getCommentsGetCommentUrl = (commentId: string,) => {




  return `/api/v1/comments/${commentId}`
}

/**
 * @summary Get Comment
 */
export const commentsGetComment = async (commentId: string, options?: Parameters<typeof customFetch>[1]): Promise<commentsGetCommentResponse> => {

  return customFetch<commentsGetCommentResponse>(getCommentsGetCommentUrl(commentId),
  {
    ...options,
    method: 'GET'


  }
);}



export type commentsUpdateCommentResponse200 = {
  data: CommentResponse
  status: 200
}

export type commentsUpdateCommentResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type commentsUpdateCommentResponseSuccess = (commentsUpdateCommentResponse200) & {
  headers: Headers;
};
export type commentsUpdateCommentResponseError = (commentsUpdateCommentResponse422) & {
  headers: Headers;
};

export type commentsUpdateCommentResponse = (commentsUpdateCommentResponseSuccess | commentsUpdateCommentResponseError)

export const getCommentsUpdateCommentUrl = (commentId: string,) => {




  return `/api/v1/comments/${commentId}`
}

/**
 * @summary Update Comment
 */
export const commentsUpdateComment = async (commentId: string,
    commentUpdateRequest: CommentUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<commentsUpdateCommentResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<commentsUpdateCommentResponse>(getCommentsUpdateCommentUrl(commentId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(commentUpdateRequest)
  }
);}



export type commentsDeleteCommentResponse204 = {
  data: void
  status: 204
}

export type commentsDeleteCommentResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type commentsDeleteCommentResponseSuccess = (commentsDeleteCommentResponse204) & {
  headers: Headers;
};
export type commentsDeleteCommentResponseError = (commentsDeleteCommentResponse422) & {
  headers: Headers;
};

export type commentsDeleteCommentResponse = (commentsDeleteCommentResponseSuccess | commentsDeleteCommentResponseError)

export const getCommentsDeleteCommentUrl = (commentId: string,) => {




  return `/api/v1/comments/${commentId}`
}

/**
 * @summary Delete Comment
 */
export const commentsDeleteComment = async (commentId: string, options?: Parameters<typeof customFetch>[1]): Promise<commentsDeleteCommentResponse> => {

  return customFetch<commentsDeleteCommentResponse>(getCommentsDeleteCommentUrl(commentId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type feedbackBatchesListFeedbackBatchesResponse200 = {
  data: BatchListResponse
  status: 200
}

export type feedbackBatchesListFeedbackBatchesResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type feedbackBatchesListFeedbackBatchesResponseSuccess = (feedbackBatchesListFeedbackBatchesResponse200) & {
  headers: Headers;
};
export type feedbackBatchesListFeedbackBatchesResponseError = (feedbackBatchesListFeedbackBatchesResponse422) & {
  headers: Headers;
};

export type feedbackBatchesListFeedbackBatchesResponse = (feedbackBatchesListFeedbackBatchesResponseSuccess | feedbackBatchesListFeedbackBatchesResponseError)

export const getFeedbackBatchesListFeedbackBatchesUrl = (params?: FeedbackBatchesListFeedbackBatchesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/feedback-batches?${stringifiedParams}` : `/api/v1/feedback-batches`
}

/**
 * @summary List Feedback Batches
 */
export const feedbackBatchesListFeedbackBatches = async (params?: FeedbackBatchesListFeedbackBatchesParams, options?: Parameters<typeof customFetch>[1]): Promise<feedbackBatchesListFeedbackBatchesResponse> => {

  return customFetch<feedbackBatchesListFeedbackBatchesResponse>(getFeedbackBatchesListFeedbackBatchesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type feedbackBatchesCreateFeedbackBatchResponse201 = {
  data: BatchResponse
  status: 201
}

export type feedbackBatchesCreateFeedbackBatchResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type feedbackBatchesCreateFeedbackBatchResponseSuccess = (feedbackBatchesCreateFeedbackBatchResponse201) & {
  headers: Headers;
};
export type feedbackBatchesCreateFeedbackBatchResponseError = (feedbackBatchesCreateFeedbackBatchResponse422) & {
  headers: Headers;
};

export type feedbackBatchesCreateFeedbackBatchResponse = (feedbackBatchesCreateFeedbackBatchResponseSuccess | feedbackBatchesCreateFeedbackBatchResponseError)

export const getFeedbackBatchesCreateFeedbackBatchUrl = () => {




  return `/api/v1/feedback-batches`
}

/**
 * @summary Create Feedback Batch
 */
export const feedbackBatchesCreateFeedbackBatch = async (batchCreateRequest: BatchCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<feedbackBatchesCreateFeedbackBatchResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<feedbackBatchesCreateFeedbackBatchResponse>(getFeedbackBatchesCreateFeedbackBatchUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(batchCreateRequest)
  }
);}



export type feedbackBatchesGetFeedbackBatchResponse200 = {
  data: BatchDetailResponse
  status: 200
}

export type feedbackBatchesGetFeedbackBatchResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type feedbackBatchesGetFeedbackBatchResponseSuccess = (feedbackBatchesGetFeedbackBatchResponse200) & {
  headers: Headers;
};
export type feedbackBatchesGetFeedbackBatchResponseError = (feedbackBatchesGetFeedbackBatchResponse422) & {
  headers: Headers;
};

export type feedbackBatchesGetFeedbackBatchResponse = (feedbackBatchesGetFeedbackBatchResponseSuccess | feedbackBatchesGetFeedbackBatchResponseError)

export const getFeedbackBatchesGetFeedbackBatchUrl = (batchId: string,) => {




  return `/api/v1/feedback-batches/${batchId}`
}

/**
 * @summary Get Feedback Batch
 */
export const feedbackBatchesGetFeedbackBatch = async (batchId: string, options?: Parameters<typeof customFetch>[1]): Promise<feedbackBatchesGetFeedbackBatchResponse> => {

  return customFetch<feedbackBatchesGetFeedbackBatchResponse>(getFeedbackBatchesGetFeedbackBatchUrl(batchId),
  {
    ...options,
    method: 'GET'


  }
);}



export type feedbackBatchesAddCommentsToBatchResponse200 = {
  data: FeedbackBatchesAddCommentsToBatch200
  status: 200
}

export type feedbackBatchesAddCommentsToBatchResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type feedbackBatchesAddCommentsToBatchResponseSuccess = (feedbackBatchesAddCommentsToBatchResponse200) & {
  headers: Headers;
};
export type feedbackBatchesAddCommentsToBatchResponseError = (feedbackBatchesAddCommentsToBatchResponse422) & {
  headers: Headers;
};

export type feedbackBatchesAddCommentsToBatchResponse = (feedbackBatchesAddCommentsToBatchResponseSuccess | feedbackBatchesAddCommentsToBatchResponseError)

export const getFeedbackBatchesAddCommentsToBatchUrl = (batchId: string,) => {




  return `/api/v1/feedback-batches/${batchId}/comments`
}

/**
 * @summary Add Comments To Batch
 */
export const feedbackBatchesAddCommentsToBatch = async (batchId: string,
    batchAddCommentsRequest: BatchAddCommentsRequest, options?: Parameters<typeof customFetch>[1]): Promise<feedbackBatchesAddCommentsToBatchResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<feedbackBatchesAddCommentsToBatchResponse>(getFeedbackBatchesAddCommentsToBatchUrl(batchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(batchAddCommentsRequest)
  }
);}



export type feedbackBatchesRemoveCommentFromBatchResponse200 = {
  data: FeedbackBatchesRemoveCommentFromBatch200
  status: 200
}

export type feedbackBatchesRemoveCommentFromBatchResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type feedbackBatchesRemoveCommentFromBatchResponseSuccess = (feedbackBatchesRemoveCommentFromBatchResponse200) & {
  headers: Headers;
};
export type feedbackBatchesRemoveCommentFromBatchResponseError = (feedbackBatchesRemoveCommentFromBatchResponse422) & {
  headers: Headers;
};

export type feedbackBatchesRemoveCommentFromBatchResponse = (feedbackBatchesRemoveCommentFromBatchResponseSuccess | feedbackBatchesRemoveCommentFromBatchResponseError)

export const getFeedbackBatchesRemoveCommentFromBatchUrl = (batchId: string,
    commentId: string,) => {




  return `/api/v1/feedback-batches/${batchId}/comments/${commentId}`
}

/**
 * @summary Remove Comment From Batch
 */
export const feedbackBatchesRemoveCommentFromBatch = async (batchId: string,
    commentId: string, options?: Parameters<typeof customFetch>[1]): Promise<feedbackBatchesRemoveCommentFromBatchResponse> => {

  return customFetch<feedbackBatchesRemoveCommentFromBatchResponse>(getFeedbackBatchesRemoveCommentFromBatchUrl(batchId,commentId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type feedbackBatchesAddEvaluationsToBatchResponse200 = {
  data: FeedbackBatchesAddEvaluationsToBatch200
  status: 200
}

export type feedbackBatchesAddEvaluationsToBatchResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type feedbackBatchesAddEvaluationsToBatchResponseSuccess = (feedbackBatchesAddEvaluationsToBatchResponse200) & {
  headers: Headers;
};
export type feedbackBatchesAddEvaluationsToBatchResponseError = (feedbackBatchesAddEvaluationsToBatchResponse422) & {
  headers: Headers;
};

export type feedbackBatchesAddEvaluationsToBatchResponse = (feedbackBatchesAddEvaluationsToBatchResponseSuccess | feedbackBatchesAddEvaluationsToBatchResponseError)

export const getFeedbackBatchesAddEvaluationsToBatchUrl = (batchId: string,) => {




  return `/api/v1/feedback-batches/${batchId}/evaluations`
}

/**
 * @summary Add Evaluations To Batch
 */
export const feedbackBatchesAddEvaluationsToBatch = async (batchId: string,
    batchAddEvaluationsRequest: BatchAddEvaluationsRequest, options?: Parameters<typeof customFetch>[1]): Promise<feedbackBatchesAddEvaluationsToBatchResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<feedbackBatchesAddEvaluationsToBatchResponse>(getFeedbackBatchesAddEvaluationsToBatchUrl(batchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(batchAddEvaluationsRequest)
  }
);}



export type feedbackBatchesRemoveEvaluationFromBatchResponse200 = {
  data: FeedbackBatchesRemoveEvaluationFromBatch200
  status: 200
}

export type feedbackBatchesRemoveEvaluationFromBatchResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type feedbackBatchesRemoveEvaluationFromBatchResponseSuccess = (feedbackBatchesRemoveEvaluationFromBatchResponse200) & {
  headers: Headers;
};
export type feedbackBatchesRemoveEvaluationFromBatchResponseError = (feedbackBatchesRemoveEvaluationFromBatchResponse422) & {
  headers: Headers;
};

export type feedbackBatchesRemoveEvaluationFromBatchResponse = (feedbackBatchesRemoveEvaluationFromBatchResponseSuccess | feedbackBatchesRemoveEvaluationFromBatchResponseError)

export const getFeedbackBatchesRemoveEvaluationFromBatchUrl = (batchId: string,
    evaluationId: string,) => {




  return `/api/v1/feedback-batches/${batchId}/evaluations/${evaluationId}`
}

/**
 * @summary Remove Evaluation From Batch
 */
export const feedbackBatchesRemoveEvaluationFromBatch = async (batchId: string,
    evaluationId: string, options?: Parameters<typeof customFetch>[1]): Promise<feedbackBatchesRemoveEvaluationFromBatchResponse> => {

  return customFetch<feedbackBatchesRemoveEvaluationFromBatchResponse>(getFeedbackBatchesRemoveEvaluationFromBatchUrl(batchId,evaluationId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type feedbackBatchesPersistBatchProposalsResponse200 = {
  data: FeedbackBatchesPersistBatchProposals200
  status: 200
}

export type feedbackBatchesPersistBatchProposalsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type feedbackBatchesPersistBatchProposalsResponseSuccess = (feedbackBatchesPersistBatchProposalsResponse200) & {
  headers: Headers;
};
export type feedbackBatchesPersistBatchProposalsResponseError = (feedbackBatchesPersistBatchProposalsResponse422) & {
  headers: Headers;
};

export type feedbackBatchesPersistBatchProposalsResponse = (feedbackBatchesPersistBatchProposalsResponseSuccess | feedbackBatchesPersistBatchProposalsResponseError)

export const getFeedbackBatchesPersistBatchProposalsUrl = (batchId: string,) => {




  return `/api/v1/feedback-batches/${batchId}/proposals`
}

/**
 * Ingests proposed draft rules and knowledge items generated by the feedback curation agent.
 * @summary Persist Batch Proposals
 */
export const feedbackBatchesPersistBatchProposals = async (batchId: string,
    batchProposalsRequest: BatchProposalsRequest, options?: Parameters<typeof customFetch>[1]): Promise<feedbackBatchesPersistBatchProposalsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<feedbackBatchesPersistBatchProposalsResponse>(getFeedbackBatchesPersistBatchProposalsUrl(batchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(batchProposalsRequest)
  }
);}



export type feedbackBatchesProcessFeedbackBatchResponse202 = {
  data: FeedbackBatchesProcessFeedbackBatch202
  status: 202
}

export type feedbackBatchesProcessFeedbackBatchResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type feedbackBatchesProcessFeedbackBatchResponseSuccess = (feedbackBatchesProcessFeedbackBatchResponse202) & {
  headers: Headers;
};
export type feedbackBatchesProcessFeedbackBatchResponseError = (feedbackBatchesProcessFeedbackBatchResponse422) & {
  headers: Headers;
};

export type feedbackBatchesProcessFeedbackBatchResponse = (feedbackBatchesProcessFeedbackBatchResponseSuccess | feedbackBatchesProcessFeedbackBatchResponseError)

export const getFeedbackBatchesProcessFeedbackBatchUrl = (batchId: string,) => {




  return `/api/v1/feedback-batches/${batchId}/process`
}

/**
 * @summary Process Feedback Batch
 */
export const feedbackBatchesProcessFeedbackBatch = async (batchId: string, options?: Parameters<typeof customFetch>[1]): Promise<feedbackBatchesProcessFeedbackBatchResponse> => {

  return customFetch<feedbackBatchesProcessFeedbackBatchResponse>(getFeedbackBatchesProcessFeedbackBatchUrl(batchId),
  {
    ...options,
    method: 'POST'


  }
);}



export type feedbackBatchesFailFeedbackBatchResponse200 = {
  data: FeedbackBatchesFailFeedbackBatch200
  status: 200
}

export type feedbackBatchesFailFeedbackBatchResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type feedbackBatchesFailFeedbackBatchResponseSuccess = (feedbackBatchesFailFeedbackBatchResponse200) & {
  headers: Headers;
};
export type feedbackBatchesFailFeedbackBatchResponseError = (feedbackBatchesFailFeedbackBatchResponse422) & {
  headers: Headers;
};

export type feedbackBatchesFailFeedbackBatchResponse = (feedbackBatchesFailFeedbackBatchResponseSuccess | feedbackBatchesFailFeedbackBatchResponseError)

export const getFeedbackBatchesFailFeedbackBatchUrl = (batchId: string,) => {




  return `/api/v1/feedback-batches/${batchId}/fail`
}

/**
 * @summary Fail Feedback Batch
 */
export const feedbackBatchesFailFeedbackBatch = async (batchId: string,
    batchFailRequest?: BatchFailRequest, options?: Parameters<typeof customFetch>[1]): Promise<feedbackBatchesFailFeedbackBatchResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<feedbackBatchesFailFeedbackBatchResponse>(getFeedbackBatchesFailFeedbackBatchUrl(batchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(batchFailRequest)
  }
);}



export type feedbackBatchesPromoteFeedbackBatchResponse200 = {
  data: FeedbackBatchesPromoteFeedbackBatch200
  status: 200
}

export type feedbackBatchesPromoteFeedbackBatchResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type feedbackBatchesPromoteFeedbackBatchResponseSuccess = (feedbackBatchesPromoteFeedbackBatchResponse200) & {
  headers: Headers;
};
export type feedbackBatchesPromoteFeedbackBatchResponseError = (feedbackBatchesPromoteFeedbackBatchResponse422) & {
  headers: Headers;
};

export type feedbackBatchesPromoteFeedbackBatchResponse = (feedbackBatchesPromoteFeedbackBatchResponseSuccess | feedbackBatchesPromoteFeedbackBatchResponseError)

export const getFeedbackBatchesPromoteFeedbackBatchUrl = (batchId: string,) => {




  return `/api/v1/feedback-batches/${batchId}/promote`
}

/**
 * Atomically promotes all approved draft rules and knowledge items in the batch to active.
 * @summary Promote Feedback Batch
 */
export const feedbackBatchesPromoteFeedbackBatch = async (batchId: string, options?: Parameters<typeof customFetch>[1]): Promise<feedbackBatchesPromoteFeedbackBatchResponse> => {

  return customFetch<feedbackBatchesPromoteFeedbackBatchResponse>(getFeedbackBatchesPromoteFeedbackBatchUrl(batchId),
  {
    ...options,
    method: 'POST'


  }
);}



export type feedbackBatchesRejectFeedbackBatchResponse200 = {
  data: FeedbackBatchesRejectFeedbackBatch200
  status: 200
}

export type feedbackBatchesRejectFeedbackBatchResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type feedbackBatchesRejectFeedbackBatchResponseSuccess = (feedbackBatchesRejectFeedbackBatchResponse200) & {
  headers: Headers;
};
export type feedbackBatchesRejectFeedbackBatchResponseError = (feedbackBatchesRejectFeedbackBatchResponse422) & {
  headers: Headers;
};

export type feedbackBatchesRejectFeedbackBatchResponse = (feedbackBatchesRejectFeedbackBatchResponseSuccess | feedbackBatchesRejectFeedbackBatchResponseError)

export const getFeedbackBatchesRejectFeedbackBatchUrl = (batchId: string,) => {




  return `/api/v1/feedback-batches/${batchId}/reject`
}

/**
 * Atomically rejects all drafts in the batch and archives the batch.
 * @summary Reject Feedback Batch
 */
export const feedbackBatchesRejectFeedbackBatch = async (batchId: string, options?: Parameters<typeof customFetch>[1]): Promise<feedbackBatchesRejectFeedbackBatchResponse> => {

  return customFetch<feedbackBatchesRejectFeedbackBatchResponse>(getFeedbackBatchesRejectFeedbackBatchUrl(batchId),
  {
    ...options,
    method: 'POST'


  }
);}



export type feedbackBatchesArchiveFeedbackBatchResponse200 = {
  data: FeedbackBatchesArchiveFeedbackBatch200
  status: 200
}

export type feedbackBatchesArchiveFeedbackBatchResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type feedbackBatchesArchiveFeedbackBatchResponseSuccess = (feedbackBatchesArchiveFeedbackBatchResponse200) & {
  headers: Headers;
};
export type feedbackBatchesArchiveFeedbackBatchResponseError = (feedbackBatchesArchiveFeedbackBatchResponse422) & {
  headers: Headers;
};

export type feedbackBatchesArchiveFeedbackBatchResponse = (feedbackBatchesArchiveFeedbackBatchResponseSuccess | feedbackBatchesArchiveFeedbackBatchResponseError)

export const getFeedbackBatchesArchiveFeedbackBatchUrl = (batchId: string,) => {




  return `/api/v1/feedback-batches/${batchId}/archive`
}

/**
 * Explicitly archives a feedback batch, marking pending drafts as rejected/archived.
 * @summary Archive Feedback Batch
 */
export const feedbackBatchesArchiveFeedbackBatch = async (batchId: string, options?: Parameters<typeof customFetch>[1]): Promise<feedbackBatchesArchiveFeedbackBatchResponse> => {

  return customFetch<feedbackBatchesArchiveFeedbackBatchResponse>(getFeedbackBatchesArchiveFeedbackBatchUrl(batchId),
  {
    ...options,
    method: 'POST'


  }
);}



export type feedbackBatchesReopenFeedbackBatchResponse200 = {
  data: FeedbackBatchesReopenFeedbackBatch200
  status: 200
}

export type feedbackBatchesReopenFeedbackBatchResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type feedbackBatchesReopenFeedbackBatchResponseSuccess = (feedbackBatchesReopenFeedbackBatchResponse200) & {
  headers: Headers;
};
export type feedbackBatchesReopenFeedbackBatchResponseError = (feedbackBatchesReopenFeedbackBatchResponse422) & {
  headers: Headers;
};

export type feedbackBatchesReopenFeedbackBatchResponse = (feedbackBatchesReopenFeedbackBatchResponseSuccess | feedbackBatchesReopenFeedbackBatchResponseError)

export const getFeedbackBatchesReopenFeedbackBatchUrl = (batchId: string,) => {




  return `/api/v1/feedback-batches/${batchId}/reopen`
}

/**
 * Reverts a review_ready feedback batch back to collecting status, deleting proposed draft changesets.
 * @summary Reopen Feedback Batch
 */
export const feedbackBatchesReopenFeedbackBatch = async (batchId: string, options?: Parameters<typeof customFetch>[1]): Promise<feedbackBatchesReopenFeedbackBatchResponse> => {

  return customFetch<feedbackBatchesReopenFeedbackBatchResponse>(getFeedbackBatchesReopenFeedbackBatchUrl(batchId),
  {
    ...options,
    method: 'POST'


  }
);}



export type rulesGetActiveRulesResponse200 = {
  data: ActiveRulesResponse
  status: 200
}

export type rulesGetActiveRulesResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type rulesGetActiveRulesResponseSuccess = (rulesGetActiveRulesResponse200) & {
  headers: Headers;
};
export type rulesGetActiveRulesResponseError = (rulesGetActiveRulesResponse422) & {
  headers: Headers;
};

export type rulesGetActiveRulesResponse = (rulesGetActiveRulesResponseSuccess | rulesGetActiveRulesResponseError)

export const getRulesGetActiveRulesUrl = () => {




  return `/api/v1/rules/active`
}

/**
 * Fast-path endpoint for agent prompt construction.
 * Retrieves active directives for agent_type or universal org-level rules,
 * filtering by condition parameters and sorted by priority descending.
 * If target_user_id is present, combines universal org rules with the user's personal rules.
 * @summary Get Active Rules
 */
export const rulesGetActiveRules = async (activeRulesRequest: ActiveRulesRequest, options?: Parameters<typeof customFetch>[1]): Promise<rulesGetActiveRulesResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<rulesGetActiveRulesResponse>(getRulesGetActiveRulesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(activeRulesRequest)
  }
);}



export type rulesListRulesResponse200 = {
  data: RuleListResponse
  status: 200
}

export type rulesListRulesResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type rulesListRulesResponseSuccess = (rulesListRulesResponse200) & {
  headers: Headers;
};
export type rulesListRulesResponseError = (rulesListRulesResponse422) & {
  headers: Headers;
};

export type rulesListRulesResponse = (rulesListRulesResponseSuccess | rulesListRulesResponseError)

export const getRulesListRulesUrl = (params?: RulesListRulesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/rules?${stringifiedParams}` : `/api/v1/rules`
}

/**
 * Lists rules for administration and curation views with search and pagination.
 * Rules with a user_id are private and only visible to the user who owns them.
 * @summary List Rules
 */
export const rulesListRules = async (params?: RulesListRulesParams, options?: Parameters<typeof customFetch>[1]): Promise<rulesListRulesResponse> => {

  return customFetch<rulesListRulesResponse>(getRulesListRulesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type rulesCreateRuleDraftResponse201 = {
  data: RuleResponse
  status: 201
}

export type rulesCreateRuleDraftResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type rulesCreateRuleDraftResponseSuccess = (rulesCreateRuleDraftResponse201) & {
  headers: Headers;
};
export type rulesCreateRuleDraftResponseError = (rulesCreateRuleDraftResponse422) & {
  headers: Headers;
};

export type rulesCreateRuleDraftResponse = (rulesCreateRuleDraftResponseSuccess | rulesCreateRuleDraftResponseError)

export const getRulesCreateRuleDraftUrl = () => {




  return `/api/v1/rules/draft`
}

/**
 * Creates a new draft rule record.
 * If is_personal is True, attaches the authenticated user's user_id.
 * @summary Create Rule Draft
 */
export const rulesCreateRuleDraft = async (ruleDraftRequest: RuleDraftRequest, options?: Parameters<typeof customFetch>[1]): Promise<rulesCreateRuleDraftResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<rulesCreateRuleDraftResponse>(getRulesCreateRuleDraftUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(ruleDraftRequest)
  }
);}



export type rulesActivateRuleResponse200 = {
  data: RuleResponse
  status: 200
}

export type rulesActivateRuleResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type rulesActivateRuleResponseSuccess = (rulesActivateRuleResponse200) & {
  headers: Headers;
};
export type rulesActivateRuleResponseError = (rulesActivateRuleResponse422) & {
  headers: Headers;
};

export type rulesActivateRuleResponse = (rulesActivateRuleResponseSuccess | rulesActivateRuleResponseError)

export const getRulesActivateRuleUrl = (ruleId: string,) => {




  return `/api/v1/rules/${ruleId}/activate`
}

/**
 * Transitions rule from draft to active.
 * If supersedes_rule_id is set, supersedes the previous active rule.
 * @summary Activate Rule
 */
export const rulesActivateRule = async (ruleId: string,
    ruleActivateRequestNull?: RuleActivateRequest | null, options?: Parameters<typeof customFetch>[1]): Promise<rulesActivateRuleResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<rulesActivateRuleResponse>(getRulesActivateRuleUrl(ruleId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(ruleActivateRequestNull)
  }
);}



export type rulesSupersedeRuleResponse200 = {
  data: RuleResponse
  status: 200
}

export type rulesSupersedeRuleResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type rulesSupersedeRuleResponseSuccess = (rulesSupersedeRuleResponse200) & {
  headers: Headers;
};
export type rulesSupersedeRuleResponseError = (rulesSupersedeRuleResponse422) & {
  headers: Headers;
};

export type rulesSupersedeRuleResponse = (rulesSupersedeRuleResponseSuccess | rulesSupersedeRuleResponseError)

export const getRulesSupersedeRuleUrl = (ruleId: string,) => {




  return `/api/v1/rules/${ruleId}/supersede`
}

/**
 * Marks the existing rule as superseded and links/activates the new revision.
 * @summary Supersede Rule
 */
export const rulesSupersedeRule = async (ruleId: string,
    ruleSupersedeRequest: RuleSupersedeRequest, options?: Parameters<typeof customFetch>[1]): Promise<rulesSupersedeRuleResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<rulesSupersedeRuleResponse>(getRulesSupersedeRuleUrl(ruleId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(ruleSupersedeRequest)
  }
);}



export type rulesRevertRuleResponse200 = {
  data: RuleResponse
  status: 200
}

export type rulesRevertRuleResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type rulesRevertRuleResponseSuccess = (rulesRevertRuleResponse200) & {
  headers: Headers;
};
export type rulesRevertRuleResponseError = (rulesRevertRuleResponse422) & {
  headers: Headers;
};

export type rulesRevertRuleResponse = (rulesRevertRuleResponseSuccess | rulesRevertRuleResponseError)

export const getRulesRevertRuleUrl = (ruleId: string,) => {




  return `/api/v1/rules/${ruleId}/revert`
}

/**
 * Reverts a rule by creating a new active version with the content and priority of a previous revision,
 * marking the currently active version in the lineage as superseded.
 * @summary Revert Rule
 */
export const rulesRevertRule = async (ruleId: string,
    ruleRevertRequestNull?: RuleRevertRequest | null, options?: Parameters<typeof customFetch>[1]): Promise<rulesRevertRuleResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<rulesRevertRuleResponse>(getRulesRevertRuleUrl(ruleId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(ruleRevertRequestNull)
  }
);}



export type rulesDeprecateRuleResponse200 = {
  data: RuleResponse
  status: 200
}

export type rulesDeprecateRuleResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type rulesDeprecateRuleResponseSuccess = (rulesDeprecateRuleResponse200) & {
  headers: Headers;
};
export type rulesDeprecateRuleResponseError = (rulesDeprecateRuleResponse422) & {
  headers: Headers;
};

export type rulesDeprecateRuleResponse = (rulesDeprecateRuleResponseSuccess | rulesDeprecateRuleResponseError)

export const getRulesDeprecateRuleUrl = (ruleId: string,) => {




  return `/api/v1/rules/${ruleId}/deprecate`
}

/**
 * Deprecates an active operational rule.
 * @summary Deprecate Rule
 */
export const rulesDeprecateRule = async (ruleId: string, options?: Parameters<typeof customFetch>[1]): Promise<rulesDeprecateRuleResponse> => {

  return customFetch<rulesDeprecateRuleResponse>(getRulesDeprecateRuleUrl(ruleId),
  {
    ...options,
    method: 'POST'


  }
);}



export type rulesGetRuleResponse200 = {
  data: RuleResponse
  status: 200
}

export type rulesGetRuleResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type rulesGetRuleResponseSuccess = (rulesGetRuleResponse200) & {
  headers: Headers;
};
export type rulesGetRuleResponseError = (rulesGetRuleResponse422) & {
  headers: Headers;
};

export type rulesGetRuleResponse = (rulesGetRuleResponseSuccess | rulesGetRuleResponseError)

export const getRulesGetRuleUrl = (ruleId: string,) => {




  return `/api/v1/rules/${ruleId}`
}

/**
 * Retrieves full details for a specific operational rule.
 * @summary Get Rule
 */
export const rulesGetRule = async (ruleId: string, options?: Parameters<typeof customFetch>[1]): Promise<rulesGetRuleResponse> => {

  return customFetch<rulesGetRuleResponse>(getRulesGetRuleUrl(ruleId),
  {
    ...options,
    method: 'GET'


  }
);}



export type rulesUpdateRuleResponse200 = {
  data: RuleResponse
  status: 200
}

export type rulesUpdateRuleResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type rulesUpdateRuleResponseSuccess = (rulesUpdateRuleResponse200) & {
  headers: Headers;
};
export type rulesUpdateRuleResponseError = (rulesUpdateRuleResponse422) & {
  headers: Headers;
};

export type rulesUpdateRuleResponse = (rulesUpdateRuleResponseSuccess | rulesUpdateRuleResponseError)

export const getRulesUpdateRuleUrl = (ruleId: string,) => {




  return `/api/v1/rules/${ruleId}`
}

/**
 * Updates editable fields of a rule record (draft or active configuration).
 * @summary Update Rule
 */
export const rulesUpdateRule = async (ruleId: string,
    ruleUpdateRequest: RuleUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<rulesUpdateRuleResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<rulesUpdateRuleResponse>(getRulesUpdateRuleUrl(ruleId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(ruleUpdateRequest)
  }
);}



export type rulesGetRuleHistoryResponse200 = {
  data: RuleResponse[]
  status: 200
}

export type rulesGetRuleHistoryResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type rulesGetRuleHistoryResponseSuccess = (rulesGetRuleHistoryResponse200) & {
  headers: Headers;
};
export type rulesGetRuleHistoryResponseError = (rulesGetRuleHistoryResponse422) & {
  headers: Headers;
};

export type rulesGetRuleHistoryResponse = (rulesGetRuleHistoryResponseSuccess | rulesGetRuleHistoryResponseError)

export const getRulesGetRuleHistoryUrl = (ruleId: string,) => {




  return `/api/v1/rules/${ruleId}/history`
}

/**
 * Retrieves the complete revision lineage chain for a rule (all predecessors and successors).
 * @summary Get Rule History
 */
export const rulesGetRuleHistory = async (ruleId: string, options?: Parameters<typeof customFetch>[1]): Promise<rulesGetRuleHistoryResponse> => {

  return customFetch<rulesGetRuleHistoryResponse>(getRulesGetRuleHistoryUrl(ruleId),
  {
    ...options,
    method: 'GET'


  }
);}



export type rulesCompactRuleInstructionResponse200 = {
  data: RuleCompactProposalResponse
  status: 200
}

export type rulesCompactRuleInstructionResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type rulesCompactRuleInstructionResponseSuccess = (rulesCompactRuleInstructionResponse200) & {
  headers: Headers;
};
export type rulesCompactRuleInstructionResponseError = (rulesCompactRuleInstructionResponse422) & {
  headers: Headers;
};

export type rulesCompactRuleInstructionResponse = (rulesCompactRuleInstructionResponseSuccess | rulesCompactRuleInstructionResponseError)

export const getRulesCompactRuleInstructionUrl = () => {




  return `/api/v1/rules/compact-instruction`
}

/**
 * Proposes a compacted version of an uncommitted or draft rule instruction (< 1,000 chars)
 * via AI Gateway.
 * @summary Compact Rule Instruction
 */
export const rulesCompactRuleInstruction = async (compactInstructionRequest: CompactInstructionRequest, options?: Parameters<typeof customFetch>[1]): Promise<rulesCompactRuleInstructionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<rulesCompactRuleInstructionResponse>(getRulesCompactRuleInstructionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(compactInstructionRequest)
  }
);}



export type rulesCompactRuleResponse200 = {
  data: RuleCompactProposalResponse
  status: 200
}

export type rulesCompactRuleResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type rulesCompactRuleResponseSuccess = (rulesCompactRuleResponse200) & {
  headers: Headers;
};
export type rulesCompactRuleResponseError = (rulesCompactRuleResponse422) & {
  headers: Headers;
};

export type rulesCompactRuleResponse = (rulesCompactRuleResponseSuccess | rulesCompactRuleResponseError)

export const getRulesCompactRuleUrl = (ruleId: string,) => {




  return `/api/v1/rules/${ruleId}/compact`
}

/**
 * Proposes a compacted version of an existing rule's instruction.
 * If create_draft is True, persists a new draft revision (status='draft', supersedes_rule_id=rule.id).
 * @summary Compact Rule
 */
export const rulesCompactRule = async (ruleId: string,
    ruleCompactRequest?: RuleCompactRequest, options?: Parameters<typeof customFetch>[1]): Promise<rulesCompactRuleResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<rulesCompactRuleResponse>(getRulesCompactRuleUrl(ruleId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(ruleCompactRequest)
  }
);}



export type knowledgeSearchKnowledgeResponse200 = {
  data: KnowledgeSearchResponse
  status: 200
}

export type knowledgeSearchKnowledgeResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type knowledgeSearchKnowledgeResponseSuccess = (knowledgeSearchKnowledgeResponse200) & {
  headers: Headers;
};
export type knowledgeSearchKnowledgeResponseError = (knowledgeSearchKnowledgeResponse422) & {
  headers: Headers;
};

export type knowledgeSearchKnowledgeResponse = (knowledgeSearchKnowledgeResponseSuccess | knowledgeSearchKnowledgeResponseError)

export const getKnowledgeSearchKnowledgeUrl = () => {




  return `/api/v1/knowledge/search`
}

/**
 * RAG semantic search against segmented knowledge chunks using pgvector cosine distance.
 * Vectors are generated on the fly via FastEmbed (all-MiniLM-L6-v2).
 * @summary Search Knowledge
 */
export const knowledgeSearchKnowledge = async (knowledgeSearchRequest: KnowledgeSearchRequest, options?: Parameters<typeof customFetch>[1]): Promise<knowledgeSearchKnowledgeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<knowledgeSearchKnowledgeResponse>(getKnowledgeSearchKnowledgeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(knowledgeSearchRequest)
  }
);}



export type knowledgeListKnowledgeItemsResponse200 = {
  data: KnowledgeItemListResponse
  status: 200
}

export type knowledgeListKnowledgeItemsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type knowledgeListKnowledgeItemsResponseSuccess = (knowledgeListKnowledgeItemsResponse200) & {
  headers: Headers;
};
export type knowledgeListKnowledgeItemsResponseError = (knowledgeListKnowledgeItemsResponse422) & {
  headers: Headers;
};

export type knowledgeListKnowledgeItemsResponse = (knowledgeListKnowledgeItemsResponseSuccess | knowledgeListKnowledgeItemsResponseError)

export const getKnowledgeListKnowledgeItemsUrl = (params?: KnowledgeListKnowledgeItemsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/knowledge/items?${stringifiedParams}` : `/api/v1/knowledge/items`
}

/**
 * Lists knowledge items scoped to the user's organization with search and pagination.
 * When snapshot_id or test_run is supplied, scopes strictly to items linked in that snapshot.
 * @summary List Knowledge Items
 */
export const knowledgeListKnowledgeItems = async (params?: KnowledgeListKnowledgeItemsParams, options?: Parameters<typeof customFetch>[1]): Promise<knowledgeListKnowledgeItemsResponse> => {

  return customFetch<knowledgeListKnowledgeItemsResponse>(getKnowledgeListKnowledgeItemsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type knowledgeCreateKnowledgeItemResponse201 = {
  data: KnowledgeItemResponse
  status: 201
}

export type knowledgeCreateKnowledgeItemResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type knowledgeCreateKnowledgeItemResponseSuccess = (knowledgeCreateKnowledgeItemResponse201) & {
  headers: Headers;
};
export type knowledgeCreateKnowledgeItemResponseError = (knowledgeCreateKnowledgeItemResponse422) & {
  headers: Headers;
};

export type knowledgeCreateKnowledgeItemResponse = (knowledgeCreateKnowledgeItemResponseSuccess | knowledgeCreateKnowledgeItemResponseError)

export const getKnowledgeCreateKnowledgeItemUrl = () => {




  return `/api/v1/knowledge/items`
}

/**
 * Creates a new knowledge item, automatically chunks text, generates embeddings,
 * and stores chunks atomically in a single transaction.
 * @summary Create Knowledge Item
 */
export const knowledgeCreateKnowledgeItem = async (knowledgeItemCreateRequest: KnowledgeItemCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<knowledgeCreateKnowledgeItemResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<knowledgeCreateKnowledgeItemResponse>(getKnowledgeCreateKnowledgeItemUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(knowledgeItemCreateRequest)
  }
);}



export type knowledgeUpdateKnowledgeItemResponse200 = {
  data: KnowledgeItemResponse
  status: 200
}

export type knowledgeUpdateKnowledgeItemResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type knowledgeUpdateKnowledgeItemResponseSuccess = (knowledgeUpdateKnowledgeItemResponse200) & {
  headers: Headers;
};
export type knowledgeUpdateKnowledgeItemResponseError = (knowledgeUpdateKnowledgeItemResponse422) & {
  headers: Headers;
};

export type knowledgeUpdateKnowledgeItemResponse = (knowledgeUpdateKnowledgeItemResponseSuccess | knowledgeUpdateKnowledgeItemResponseError)

export const getKnowledgeUpdateKnowledgeItemUrl = (itemId: string,) => {




  return `/api/v1/knowledge/items/${itemId}`
}

/**
 * Updates knowledge item details and re-indexes vector chunks if content changed.
 * @summary Update Knowledge Item
 */
export const knowledgeUpdateKnowledgeItem = async (itemId: string,
    knowledgeItemUpdateRequest: KnowledgeItemUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<knowledgeUpdateKnowledgeItemResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<knowledgeUpdateKnowledgeItemResponse>(getKnowledgeUpdateKnowledgeItemUrl(itemId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(knowledgeItemUpdateRequest)
  }
);}



export type knowledgeGetKnowledgeItemResponse200 = {
  data: KnowledgeItemResponse
  status: 200
}

export type knowledgeGetKnowledgeItemResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type knowledgeGetKnowledgeItemResponseSuccess = (knowledgeGetKnowledgeItemResponse200) & {
  headers: Headers;
};
export type knowledgeGetKnowledgeItemResponseError = (knowledgeGetKnowledgeItemResponse422) & {
  headers: Headers;
};

export type knowledgeGetKnowledgeItemResponse = (knowledgeGetKnowledgeItemResponseSuccess | knowledgeGetKnowledgeItemResponseError)

export const getKnowledgeGetKnowledgeItemUrl = (itemId: string,) => {




  return `/api/v1/knowledge/items/${itemId}`
}

/**
 * Retrieves full details for a specific knowledge item.
 * @summary Get Knowledge Item
 */
export const knowledgeGetKnowledgeItem = async (itemId: string, options?: Parameters<typeof customFetch>[1]): Promise<knowledgeGetKnowledgeItemResponse> => {

  return customFetch<knowledgeGetKnowledgeItemResponse>(getKnowledgeGetKnowledgeItemUrl(itemId),
  {
    ...options,
    method: 'GET'


  }
);}



export type knowledgeRollbackKnowledgeItemResponse200 = {
  data: KnowledgeItemResponse
  status: 200
}

export type knowledgeRollbackKnowledgeItemResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type knowledgeRollbackKnowledgeItemResponseSuccess = (knowledgeRollbackKnowledgeItemResponse200) & {
  headers: Headers;
};
export type knowledgeRollbackKnowledgeItemResponseError = (knowledgeRollbackKnowledgeItemResponse422) & {
  headers: Headers;
};

export type knowledgeRollbackKnowledgeItemResponse = (knowledgeRollbackKnowledgeItemResponseSuccess | knowledgeRollbackKnowledgeItemResponseError)

export const getKnowledgeRollbackKnowledgeItemUrl = (itemId: string,) => {




  return `/api/v1/knowledge/items/${itemId}/rollback`
}

/**
 * Marks a knowledge item as archived/rolled back.
 * @summary Rollback Knowledge Item
 */
export const knowledgeRollbackKnowledgeItem = async (itemId: string,
    rollbackRequest: RollbackRequest, options?: Parameters<typeof customFetch>[1]): Promise<knowledgeRollbackKnowledgeItemResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<knowledgeRollbackKnowledgeItemResponse>(getKnowledgeRollbackKnowledgeItemUrl(itemId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(rollbackRequest)
  }
);}



export type knowledgeGetKnowledgeItemChunksResponse200 = {
  data: KnowledgeChunkResponse[]
  status: 200
}

export type knowledgeGetKnowledgeItemChunksResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type knowledgeGetKnowledgeItemChunksResponseSuccess = (knowledgeGetKnowledgeItemChunksResponse200) & {
  headers: Headers;
};
export type knowledgeGetKnowledgeItemChunksResponseError = (knowledgeGetKnowledgeItemChunksResponse422) & {
  headers: Headers;
};

export type knowledgeGetKnowledgeItemChunksResponse = (knowledgeGetKnowledgeItemChunksResponseSuccess | knowledgeGetKnowledgeItemChunksResponseError)

export const getKnowledgeGetKnowledgeItemChunksUrl = (itemId: string,) => {




  return `/api/v1/knowledge/items/${itemId}/chunks`
}

/**
 * Retrieves segmented chunks and vector embedding statuses for a knowledge item.
 * @summary Get Knowledge Item Chunks
 */
export const knowledgeGetKnowledgeItemChunks = async (itemId: string, options?: Parameters<typeof customFetch>[1]): Promise<knowledgeGetKnowledgeItemChunksResponse> => {

  return customFetch<knowledgeGetKnowledgeItemChunksResponse>(getKnowledgeGetKnowledgeItemChunksUrl(itemId),
  {
    ...options,
    method: 'GET'


  }
);}



export type knowledgeGetKnowledgeChunkResponse200 = {
  data: KnowledgeChunkDetailResponse
  status: 200
}

export type knowledgeGetKnowledgeChunkResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type knowledgeGetKnowledgeChunkResponseSuccess = (knowledgeGetKnowledgeChunkResponse200) & {
  headers: Headers;
};
export type knowledgeGetKnowledgeChunkResponseError = (knowledgeGetKnowledgeChunkResponse422) & {
  headers: Headers;
};

export type knowledgeGetKnowledgeChunkResponse = (knowledgeGetKnowledgeChunkResponseSuccess | knowledgeGetKnowledgeChunkResponseError)

export const getKnowledgeGetKnowledgeChunkUrl = (chunkId: string,) => {




  return `/api/v1/knowledge/chunks/${chunkId}`
}

/**
 * Retrieves full details for a specific knowledge chunk, including embedding status
 * and parent knowledge item summary.
 * @summary Get Knowledge Chunk
 */
export const knowledgeGetKnowledgeChunk = async (chunkId: string, options?: Parameters<typeof customFetch>[1]): Promise<knowledgeGetKnowledgeChunkResponse> => {

  return customFetch<knowledgeGetKnowledgeChunkResponse>(getKnowledgeGetKnowledgeChunkUrl(chunkId),
  {
    ...options,
    method: 'GET'


  }
);}



export type agentsListModelsResponse200 = {
  data: ModelCatalogResponse
  status: 200
}

export type agentsListModelsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type agentsListModelsResponseSuccess = (agentsListModelsResponse200) & {
  headers: Headers;
};
export type agentsListModelsResponseError = (agentsListModelsResponse422) & {
  headers: Headers;
};

export type agentsListModelsResponse = (agentsListModelsResponseSuccess | agentsListModelsResponseError)

export const getAgentsListModelsUrl = () => {




  return `/api/v1/agents/models`
}

/**
 * Retrieve available foundation models from AI Gateway (OpenRouter + Gemini).
 * @summary List Available Foundation Models
 */
export const agentsListModels = async ( options?: Parameters<typeof customFetch>[1]): Promise<agentsListModelsResponse> => {

  return customFetch<agentsListModelsResponse>(getAgentsListModelsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type agentsListProvidersResponse200 = {
  data: ProviderCatalogResponse
  status: 200
}

export type agentsListProvidersResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type agentsListProvidersResponseSuccess = (agentsListProvidersResponse200) & {
  headers: Headers;
};
export type agentsListProvidersResponseError = (agentsListProvidersResponse422) & {
  headers: Headers;
};

export type agentsListProvidersResponse = (agentsListProvidersResponseSuccess | agentsListProvidersResponseError)

export const getAgentsListProvidersUrl = (params?: AgentsListProvidersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/agents/providers?${stringifiedParams}` : `/api/v1/agents/providers`
}

/**
 * Retrieve live available hosting providers for a specific model (or global) directly from OpenRouter API.
 * @summary List Available OpenRouter Providers for Model
 */
export const agentsListProviders = async (params?: AgentsListProvidersParams, options?: Parameters<typeof customFetch>[1]): Promise<agentsListProvidersResponse> => {

  return customFetch<agentsListProvidersResponse>(getAgentsListProvidersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type agentsListConfigurationsResponse200 = {
  data: AgentConfigurationResponse[]
  status: 200
}

export type agentsListConfigurationsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type agentsListConfigurationsResponseSuccess = (agentsListConfigurationsResponse200) & {
  headers: Headers;
};
export type agentsListConfigurationsResponseError = (agentsListConfigurationsResponse422) & {
  headers: Headers;
};

export type agentsListConfigurationsResponse = (agentsListConfigurationsResponseSuccess | agentsListConfigurationsResponseError)

export const getAgentsListConfigurationsUrl = () => {




  return `/api/v1/agents/configurations`
}

/**
 * Retrieve dynamic configurations for all agent types in the organization.
 * @summary List All Agent Configurations
 */
export const agentsListConfigurations = async ( options?: Parameters<typeof customFetch>[1]): Promise<agentsListConfigurationsResponse> => {

  return customFetch<agentsListConfigurationsResponse>(getAgentsListConfigurationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type agentsGetConfigurationResponse200 = {
  data: AgentConfigurationResponse
  status: 200
}

export type agentsGetConfigurationResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type agentsGetConfigurationResponseSuccess = (agentsGetConfigurationResponse200) & {
  headers: Headers;
};
export type agentsGetConfigurationResponseError = (agentsGetConfigurationResponse422) & {
  headers: Headers;
};

export type agentsGetConfigurationResponse = (agentsGetConfigurationResponseSuccess | agentsGetConfigurationResponseError)

export const getAgentsGetConfigurationUrl = (agentType: string,) => {




  return `/api/v1/agents/${agentType}/configuration`
}

/**
 * Retrieve dynamic configuration for a specific agent type.
 * @summary Get Agent Configuration
 */
export const agentsGetConfiguration = async (agentType: string, options?: Parameters<typeof customFetch>[1]): Promise<agentsGetConfigurationResponse> => {

  return customFetch<agentsGetConfigurationResponse>(getAgentsGetConfigurationUrl(agentType),
  {
    ...options,
    method: 'GET'


  }
);}



export type agentsUpdateConfigurationResponse200 = {
  data: AgentConfigurationResponse
  status: 200
}

export type agentsUpdateConfigurationResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type agentsUpdateConfigurationResponseSuccess = (agentsUpdateConfigurationResponse200) & {
  headers: Headers;
};
export type agentsUpdateConfigurationResponseError = (agentsUpdateConfigurationResponse422) & {
  headers: Headers;
};

export type agentsUpdateConfigurationResponse = (agentsUpdateConfigurationResponseSuccess | agentsUpdateConfigurationResponseError)

export const getAgentsUpdateConfigurationUrl = (agentType: string,) => {




  return `/api/v1/agents/${agentType}/configuration`
}

/**
 * Update or create dynamic configuration for a specific agent type.
 * @summary Update Agent Configuration
 */
export const agentsUpdateConfiguration = async (agentType: string,
    agentConfigurationUpdateRequest: AgentConfigurationUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<agentsUpdateConfigurationResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<agentsUpdateConfigurationResponse>(getAgentsUpdateConfigurationUrl(agentType),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(agentConfigurationUpdateRequest)
  }
);}



export type agentsResetConfigurationResponse204 = {
  data: void
  status: 204
}

export type agentsResetConfigurationResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type agentsResetConfigurationResponseSuccess = (agentsResetConfigurationResponse204) & {
  headers: Headers;
};
export type agentsResetConfigurationResponseError = (agentsResetConfigurationResponse422) & {
  headers: Headers;
};

export type agentsResetConfigurationResponse = (agentsResetConfigurationResponseSuccess | agentsResetConfigurationResponseError)

export const getAgentsResetConfigurationUrl = (agentType: string,) => {




  return `/api/v1/agents/${agentType}/configuration`
}

/**
 * Reset configuration for an agent type by removing the customized row.
 * @summary Reset Agent Configuration to Default
 */
export const agentsResetConfiguration = async (agentType: string, options?: Parameters<typeof customFetch>[1]): Promise<agentsResetConfigurationResponse> => {

  return customFetch<agentsResetConfigurationResponse>(getAgentsResetConfigurationUrl(agentType),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type guardrailsValidateResponse200 = {
  data: GuardrailValidateResponse
  status: 200
}

export type guardrailsValidateResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type guardrailsValidateResponseSuccess = (guardrailsValidateResponse200) & {
  headers: Headers;
};
export type guardrailsValidateResponseError = (guardrailsValidateResponse422) & {
  headers: Headers;
};

export type guardrailsValidateResponse = (guardrailsValidateResponseSuccess | guardrailsValidateResponseError)

export const getGuardrailsValidateUrl = () => {




  return `/api/v1/guardrails/validate`
}

/**
 * High-speed runtime validation evaluating inbound query against dual manifold.
 * @summary Validate Query Against Guardrails
 */
export const guardrailsValidate = async (guardrailValidateRequest: GuardrailValidateRequest, options?: Parameters<typeof customFetch>[1]): Promise<guardrailsValidateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<guardrailsValidateResponse>(getGuardrailsValidateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(guardrailValidateRequest)
  }
);}



export type guardrailsListItemsResponse200 = {
  data: GuardrailItemResponse[]
  status: 200
}

export type guardrailsListItemsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type guardrailsListItemsResponseSuccess = (guardrailsListItemsResponse200) & {
  headers: Headers;
};
export type guardrailsListItemsResponseError = (guardrailsListItemsResponse422) & {
  headers: Headers;
};

export type guardrailsListItemsResponse = (guardrailsListItemsResponseSuccess | guardrailsListItemsResponseError)

export const getGuardrailsListItemsUrl = (params?: GuardrailsListItemsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/guardrails/items?${stringifiedParams}` : `/api/v1/guardrails/items`
}

/**
 * List configured guardrail policies for the organization.
 * @summary List Guardrail Items
 */
export const guardrailsListItems = async (params?: GuardrailsListItemsParams, options?: Parameters<typeof customFetch>[1]): Promise<guardrailsListItemsResponse> => {

  return customFetch<guardrailsListItemsResponse>(getGuardrailsListItemsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type guardrailsCreateItemResponse200 = {
  data: GuardrailItemResponse
  status: 200
}

export type guardrailsCreateItemResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type guardrailsCreateItemResponseSuccess = (guardrailsCreateItemResponse200) & {
  headers: Headers;
};
export type guardrailsCreateItemResponseError = (guardrailsCreateItemResponse422) & {
  headers: Headers;
};

export type guardrailsCreateItemResponse = (guardrailsCreateItemResponseSuccess | guardrailsCreateItemResponseError)

export const getGuardrailsCreateItemUrl = () => {




  return `/api/v1/guardrails/items`
}

/**
 * Create a new guardrail policy item with optional initial anchors.
 * @summary Create Guardrail Item
 */
export const guardrailsCreateItem = async (guardrailItemCreateRequest: GuardrailItemCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<guardrailsCreateItemResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<guardrailsCreateItemResponse>(getGuardrailsCreateItemUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(guardrailItemCreateRequest)
  }
);}



export type guardrailsGetItemResponse200 = {
  data: GuardrailItemDetailResponse
  status: 200
}

export type guardrailsGetItemResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type guardrailsGetItemResponseSuccess = (guardrailsGetItemResponse200) & {
  headers: Headers;
};
export type guardrailsGetItemResponseError = (guardrailsGetItemResponse422) & {
  headers: Headers;
};

export type guardrailsGetItemResponse = (guardrailsGetItemResponseSuccess | guardrailsGetItemResponseError)

export const getGuardrailsGetItemUrl = (itemId: string,) => {




  return `/api/v1/guardrails/items/${itemId}`
}

/**
 * Retrieve details for a guardrail item including its anchors.
 * @summary Get Guardrail Item
 */
export const guardrailsGetItem = async (itemId: string, options?: Parameters<typeof customFetch>[1]): Promise<guardrailsGetItemResponse> => {

  return customFetch<guardrailsGetItemResponse>(getGuardrailsGetItemUrl(itemId),
  {
    ...options,
    method: 'GET'


  }
);}



export type guardrailsUpdateItemResponse200 = {
  data: GuardrailItemDetailResponse
  status: 200
}

export type guardrailsUpdateItemResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type guardrailsUpdateItemResponseSuccess = (guardrailsUpdateItemResponse200) & {
  headers: Headers;
};
export type guardrailsUpdateItemResponseError = (guardrailsUpdateItemResponse422) & {
  headers: Headers;
};

export type guardrailsUpdateItemResponse = (guardrailsUpdateItemResponseSuccess | guardrailsUpdateItemResponseError)

export const getGuardrailsUpdateItemUrl = (itemId: string,) => {




  return `/api/v1/guardrails/items/${itemId}`
}

/**
 * Update an existing guardrail item and optionally its anchors.
 * @summary Update Guardrail Item
 */
export const guardrailsUpdateItem = async (itemId: string,
    guardrailItemUpdateRequest: GuardrailItemUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<guardrailsUpdateItemResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<guardrailsUpdateItemResponse>(getGuardrailsUpdateItemUrl(itemId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(guardrailItemUpdateRequest)
  }
);}



export type guardrailsDeleteItemResponse200 = {
  data: unknown
  status: 200
}

export type guardrailsDeleteItemResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type guardrailsDeleteItemResponseSuccess = (guardrailsDeleteItemResponse200) & {
  headers: Headers;
};
export type guardrailsDeleteItemResponseError = (guardrailsDeleteItemResponse422) & {
  headers: Headers;
};

export type guardrailsDeleteItemResponse = (guardrailsDeleteItemResponseSuccess | guardrailsDeleteItemResponseError)

export const getGuardrailsDeleteItemUrl = (itemId: string,) => {




  return `/api/v1/guardrails/items/${itemId}`
}

/**
 * Delete a guardrail item and its associated anchors.
 * @summary Delete Guardrail Item
 */
export const guardrailsDeleteItem = async (itemId: string, options?: Parameters<typeof customFetch>[1]): Promise<guardrailsDeleteItemResponse> => {

  return customFetch<guardrailsDeleteItemResponse>(getGuardrailsDeleteItemUrl(itemId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type guardrailsBatchAnchorsResponse200 = {
  data: unknown
  status: 200
}

export type guardrailsBatchAnchorsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type guardrailsBatchAnchorsResponseSuccess = (guardrailsBatchAnchorsResponse200) & {
  headers: Headers;
};
export type guardrailsBatchAnchorsResponseError = (guardrailsBatchAnchorsResponse422) & {
  headers: Headers;
};

export type guardrailsBatchAnchorsResponse = (guardrailsBatchAnchorsResponseSuccess | guardrailsBatchAnchorsResponseError)

export const getGuardrailsBatchAnchorsUrl = () => {




  return `/api/v1/guardrails/anchors/batch`
}

/**
 * Ingest and automatically compute embeddings for a batch of anchor phrases.
 * @summary Batch Ingest Anchors
 */
export const guardrailsBatchAnchors = async (batchAnchorIngestRequest: BatchAnchorIngestRequest, options?: Parameters<typeof customFetch>[1]): Promise<guardrailsBatchAnchorsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<guardrailsBatchAnchorsResponse>(getGuardrailsBatchAnchorsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(batchAnchorIngestRequest)
  }
);}



export type guardrailsSeedTaxonomiesResponse200 = {
  data: unknown
  status: 200
}

export type guardrailsSeedTaxonomiesResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type guardrailsSeedTaxonomiesResponseSuccess = (guardrailsSeedTaxonomiesResponse200) & {
  headers: Headers;
};
export type guardrailsSeedTaxonomiesResponseError = (guardrailsSeedTaxonomiesResponse422) & {
  headers: Headers;
};

export type guardrailsSeedTaxonomiesResponse = (guardrailsSeedTaxonomiesResponseSuccess | guardrailsSeedTaxonomiesResponseError)

export const getGuardrailsSeedTaxonomiesUrl = () => {




  return `/api/v1/guardrails/seed`
}

/**
 * Seed standard Frontdesk negative and positive manifold anchors.
 * @summary Seed Frontdesk Taxonomies
 */
export const guardrailsSeedTaxonomies = async ( options?: Parameters<typeof customFetch>[1]): Promise<guardrailsSeedTaxonomiesResponse> => {

  return customFetch<guardrailsSeedTaxonomiesResponse>(getGuardrailsSeedTaxonomiesUrl(),
  {
    ...options,
    method: 'POST'


  }
);}



export type simulationListModelsResponse200 = {
  data: ModelCatalogResponse
  status: 200
}

export type simulationListModelsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type simulationListModelsResponseSuccess = (simulationListModelsResponse200) & {
  headers: Headers;
};
export type simulationListModelsResponseError = (simulationListModelsResponse422) & {
  headers: Headers;
};

export type simulationListModelsResponse = (simulationListModelsResponseSuccess | simulationListModelsResponseError)

export const getSimulationListModelsUrl = () => {




  return `/api/v1/simulate/models`
}

/**
 * Proxies request for available models to AI Gateway.
 * @summary List Available Simulation Models
 */
export const simulationListModels = async ( options?: Parameters<typeof customFetch>[1]): Promise<simulationListModelsResponse> => {

  return customFetch<simulationListModelsResponse>(getSimulationListModelsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type simulationRunSimulationResponse200 = {
  data: SimulationResponse
  status: 200
}

export type simulationRunSimulationResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type simulationRunSimulationResponseSuccess = (simulationRunSimulationResponse200) & {
  headers: Headers;
};
export type simulationRunSimulationResponseError = (simulationRunSimulationResponse422) & {
  headers: Headers;
};

export type simulationRunSimulationResponse = (simulationRunSimulationResponseSuccess | simulationRunSimulationResponseError)

export const getSimulationRunSimulationUrl = () => {




  return `/api/v1/simulate`
}

/**
 * Proxies pre-merge simulation request to AI Platform Gateway with validated tenant org context.
 * @summary Run Simulation
 */
export const simulationRunSimulation = async (simulationRequest: SimulationRequest, options?: Parameters<typeof customFetch>[1]): Promise<simulationRunSimulationResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<simulationRunSimulationResponse>(getSimulationRunSimulationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(simulationRequest)
  }
);}



export type viewsListResponse200 = {
  data: ConversationViewResponse[]
  status: 200
}

export type viewsListResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type viewsListResponseSuccess = (viewsListResponse200) & {
  headers: Headers;
};
export type viewsListResponseError = (viewsListResponse422) & {
  headers: Headers;
};

export type viewsListResponse = (viewsListResponseSuccess | viewsListResponseError)

export const getViewsListUrl = () => {




  return `/api/v1/views`
}

/**
 * List accessible conversation views (global views and private views owned by the current user).
 * @summary List Views
 */
export const viewsList = async ( options?: Parameters<typeof customFetch>[1]): Promise<viewsListResponse> => {

  return customFetch<viewsListResponse>(getViewsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type viewsCreateResponse201 = {
  data: ConversationViewResponse
  status: 201
}

export type viewsCreateResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type viewsCreateResponseSuccess = (viewsCreateResponse201) & {
  headers: Headers;
};
export type viewsCreateResponseError = (viewsCreateResponse422) & {
  headers: Headers;
};

export type viewsCreateResponse = (viewsCreateResponseSuccess | viewsCreateResponseError)

export const getViewsCreateUrl = () => {




  return `/api/v1/views`
}

/**
 * Create a new conversation view (global or private).
 * @summary Create View
 */
export const viewsCreate = async (conversationViewCreateRequest: ConversationViewCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<viewsCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<viewsCreateResponse>(getViewsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(conversationViewCreateRequest)
  }
);}



export type viewsGetResponse200 = {
  data: ConversationViewResponse
  status: 200
}

export type viewsGetResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type viewsGetResponseSuccess = (viewsGetResponse200) & {
  headers: Headers;
};
export type viewsGetResponseError = (viewsGetResponse422) & {
  headers: Headers;
};

export type viewsGetResponse = (viewsGetResponseSuccess | viewsGetResponseError)

export const getViewsGetUrl = (viewId: string,) => {




  return `/api/v1/views/${viewId}`
}

/**
 * Retrieve a single conversation view by ID.
 * @summary Get View
 */
export const viewsGet = async (viewId: string, options?: Parameters<typeof customFetch>[1]): Promise<viewsGetResponse> => {

  return customFetch<viewsGetResponse>(getViewsGetUrl(viewId),
  {
    ...options,
    method: 'GET'


  }
);}



export type viewsUpdateResponse200 = {
  data: ConversationViewResponse
  status: 200
}

export type viewsUpdateResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type viewsUpdateResponseSuccess = (viewsUpdateResponse200) & {
  headers: Headers;
};
export type viewsUpdateResponseError = (viewsUpdateResponse422) & {
  headers: Headers;
};

export type viewsUpdateResponse = (viewsUpdateResponseSuccess | viewsUpdateResponseError)

export const getViewsUpdateUrl = (viewId: string,) => {




  return `/api/v1/views/${viewId}`
}

/**
 * Update or rename an existing conversation view.
 * @summary Update View
 */
export const viewsUpdate = async (viewId: string,
    conversationViewUpdateRequest: ConversationViewUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<viewsUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<viewsUpdateResponse>(getViewsUpdateUrl(viewId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(conversationViewUpdateRequest)
  }
);}



export type viewsDeleteResponse204 = {
  data: void
  status: 204
}

export type viewsDeleteResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type viewsDeleteResponseSuccess = (viewsDeleteResponse204) & {
  headers: Headers;
};
export type viewsDeleteResponseError = (viewsDeleteResponse422) & {
  headers: Headers;
};

export type viewsDeleteResponse = (viewsDeleteResponseSuccess | viewsDeleteResponseError)

export const getViewsDeleteUrl = (viewId: string,) => {




  return `/api/v1/views/${viewId}`
}

/**
 * Delete a conversation view.
 * @summary Delete View
 */
export const viewsDelete = async (viewId: string, options?: Parameters<typeof customFetch>[1]): Promise<viewsDeleteResponse> => {

  return customFetch<viewsDeleteResponse>(getViewsDeleteUrl(viewId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type viewsSetDefaultResponse200 = {
  data: ConversationViewResponse
  status: 200
}

export type viewsSetDefaultResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type viewsSetDefaultResponseSuccess = (viewsSetDefaultResponse200) & {
  headers: Headers;
};
export type viewsSetDefaultResponseError = (viewsSetDefaultResponse422) & {
  headers: Headers;
};

export type viewsSetDefaultResponse = (viewsSetDefaultResponseSuccess | viewsSetDefaultResponseError)

export const getViewsSetDefaultUrl = (viewId: string,) => {




  return `/api/v1/views/${viewId}/set-default`
}

/**
 * Designate this conversation view as the default for the current user.
 * @summary Set Default View
 */
export const viewsSetDefault = async (viewId: string, options?: Parameters<typeof customFetch>[1]): Promise<viewsSetDefaultResponse> => {

  return customFetch<viewsSetDefaultResponse>(getViewsSetDefaultUrl(viewId),
  {
    ...options,
    method: 'POST'


  }
);}



export type viewsClearDefaultResponse200 = {
  data: ConversationViewResponse
  status: 200
}

export type viewsClearDefaultResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type viewsClearDefaultResponseSuccess = (viewsClearDefaultResponse200) & {
  headers: Headers;
};
export type viewsClearDefaultResponseError = (viewsClearDefaultResponse422) & {
  headers: Headers;
};

export type viewsClearDefaultResponse = (viewsClearDefaultResponseSuccess | viewsClearDefaultResponseError)

export const getViewsClearDefaultUrl = (viewId: string,) => {




  return `/api/v1/views/${viewId}/clear-default`
}

/**
 * Clear default view designation for the current user if this view is their default.
 * @summary Clear Default View
 */
export const viewsClearDefault = async (viewId: string, options?: Parameters<typeof customFetch>[1]): Promise<viewsClearDefaultResponse> => {

  return customFetch<viewsClearDefaultResponse>(getViewsClearDefaultUrl(viewId),
  {
    ...options,
    method: 'POST'


  }
);}



export type upsertGoogleIntegrationResponse200 = {
  data: GoogleIntegrationResponse
  status: 200
}

export type upsertGoogleIntegrationResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type upsertGoogleIntegrationResponseSuccess = (upsertGoogleIntegrationResponse200) & {
  headers: Headers;
};
export type upsertGoogleIntegrationResponseError = (upsertGoogleIntegrationResponse422) & {
  headers: Headers;
};

export type upsertGoogleIntegrationResponse = (upsertGoogleIntegrationResponseSuccess | upsertGoogleIntegrationResponseError)

export const getUpsertGoogleIntegrationUrl = () => {




  return `/api/v1/integrations/google`
}

/**
 * Persist or update Google Workspace integration record with encrypted credentials.
 * Requires Service Account or Tenant Admin Bearer token.
 * @summary Upsert Google Integration
 */
export const upsertGoogleIntegration = async (googleIntegrationUpsertRequest: GoogleIntegrationUpsertRequest, options?: Parameters<typeof customFetch>[1]): Promise<upsertGoogleIntegrationResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<upsertGoogleIntegrationResponse>(getUpsertGoogleIntegrationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(googleIntegrationUpsertRequest)
  }
);}



export type getGoogleIntegrationResponse200 = {
  data: GoogleIntegrationDetailResponse
  status: 200
}

export type getGoogleIntegrationResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getGoogleIntegrationResponseSuccess = (getGoogleIntegrationResponse200) & {
  headers: Headers;
};
export type getGoogleIntegrationResponseError = (getGoogleIntegrationResponse422) & {
  headers: Headers;
};

export type getGoogleIntegrationResponse = (getGoogleIntegrationResponseSuccess | getGoogleIntegrationResponseError)

export const getGetGoogleIntegrationUrl = (params?: GetGoogleIntegrationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/integrations/google?${stringifiedParams}` : `/api/v1/integrations/google`
}

/**
 * Retrieve active Google Workspace integration credentials and token metadata.
 * Matches by email, user_id, or defaults to active integration for authenticated organization.
 * @summary Get Google Integration
 */
export const getGoogleIntegration = async (params?: GetGoogleIntegrationParams, options?: Parameters<typeof customFetch>[1]): Promise<getGoogleIntegrationResponse> => {

  return customFetch<getGoogleIntegrationResponse>(getGetGoogleIntegrationUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type updateGoogleIntegrationTokenResponse200 = {
  data: GoogleTokenUpdateResponse
  status: 200
}

export type updateGoogleIntegrationTokenResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type updateGoogleIntegrationTokenResponseSuccess = (updateGoogleIntegrationTokenResponse200) & {
  headers: Headers;
};
export type updateGoogleIntegrationTokenResponseError = (updateGoogleIntegrationTokenResponse422) & {
  headers: Headers;
};

export type updateGoogleIntegrationTokenResponse = (updateGoogleIntegrationTokenResponseSuccess | updateGoogleIntegrationTokenResponseError)

export const getUpdateGoogleIntegrationTokenUrl = () => {




  return `/api/v1/integrations/google/token`
}

/**
 * Update refreshed access token and expiration for an existing integration.
 * @summary Update Google Integration Token
 */
export const updateGoogleIntegrationToken = async (googleTokenUpdateRequest: GoogleTokenUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<updateGoogleIntegrationTokenResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<updateGoogleIntegrationTokenResponse>(getUpdateGoogleIntegrationTokenUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(googleTokenUpdateRequest)
  }
);}



export type updateGoogleIntegrationWatchResponse200 = {
  data: GoogleWatchUpdateResponse
  status: 200
}

export type updateGoogleIntegrationWatchResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type updateGoogleIntegrationWatchResponseSuccess = (updateGoogleIntegrationWatchResponse200) & {
  headers: Headers;
};
export type updateGoogleIntegrationWatchResponseError = (updateGoogleIntegrationWatchResponse422) & {
  headers: Headers;
};

export type updateGoogleIntegrationWatchResponse = (updateGoogleIntegrationWatchResponseSuccess | updateGoogleIntegrationWatchResponseError)

export const getUpdateGoogleIntegrationWatchUrl = () => {




  return `/api/v1/integrations/google/watch`
}

/**
 * Update Gmail watch history ID and expiration for an existing integration.
 * @summary Update Google Integration Watch
 */
export const updateGoogleIntegrationWatch = async (googleWatchUpdateRequest: GoogleWatchUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<updateGoogleIntegrationWatchResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<updateGoogleIntegrationWatchResponse>(getUpdateGoogleIntegrationWatchUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(googleWatchUpdateRequest)
  }
);}



export type updateGoogleIntegrationStatusResponse200 = {
  data: GoogleIntegrationResponse
  status: 200
}

export type updateGoogleIntegrationStatusResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type updateGoogleIntegrationStatusResponseSuccess = (updateGoogleIntegrationStatusResponse200) & {
  headers: Headers;
};
export type updateGoogleIntegrationStatusResponseError = (updateGoogleIntegrationStatusResponse422) & {
  headers: Headers;
};

export type updateGoogleIntegrationStatusResponse = (updateGoogleIntegrationStatusResponseSuccess | updateGoogleIntegrationStatusResponseError)

export const getUpdateGoogleIntegrationStatusUrl = () => {




  return `/api/v1/integrations/google/status`
}

/**
 * Update integration status ('active', 'expired', 'revoked').
 * @summary Update Google Integration Status
 */
export const updateGoogleIntegrationStatus = async (googleStatusUpdateRequest: GoogleStatusUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<updateGoogleIntegrationStatusResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<updateGoogleIntegrationStatusResponse>(getUpdateGoogleIntegrationStatusUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(googleStatusUpdateRequest)
  }
);}



export type listActiveGoogleIntegrationsResponse200 = {
  data: GoogleIntegrationDetailResponse[]
  status: 200
}

export type listActiveGoogleIntegrationsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listActiveGoogleIntegrationsResponseSuccess = (listActiveGoogleIntegrationsResponse200) & {
  headers: Headers;
};
export type listActiveGoogleIntegrationsResponseError = (listActiveGoogleIntegrationsResponse422) & {
  headers: Headers;
};

export type listActiveGoogleIntegrationsResponse = (listActiveGoogleIntegrationsResponseSuccess | listActiveGoogleIntegrationsResponseError)

export const getListActiveGoogleIntegrationsUrl = () => {




  return `/api/v1/integrations/google/active`
}

/**
 * Retrieve all active Google Workspace integrations for polling workers.
 * @summary List Active Google Integrations
 */
export const listActiveGoogleIntegrations = async ( options?: Parameters<typeof customFetch>[1]): Promise<listActiveGoogleIntegrationsResponse> => {

  return customFetch<listActiveGoogleIntegrationsResponse>(getListActiveGoogleIntegrationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type recordProcessedMessageResponse200 = {
  data: ProcessedMessageResponse
  status: 200
}

export type recordProcessedMessageResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type recordProcessedMessageResponseSuccess = (recordProcessedMessageResponse200) & {
  headers: Headers;
};
export type recordProcessedMessageResponseError = (recordProcessedMessageResponse422) & {
  headers: Headers;
};

export type recordProcessedMessageResponse = (recordProcessedMessageResponseSuccess | recordProcessedMessageResponseError)

export const getRecordProcessedMessageUrl = () => {




  return `/api/v1/integrations/google/messages`
}

/**
 * Record or update an inbound email message in email_drafting_processed_messages for idempotency.
 * @summary Record Processed Message
 */
export const recordProcessedMessage = async (processedMessageCreateRequest: ProcessedMessageCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<recordProcessedMessageResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<recordProcessedMessageResponse>(getRecordProcessedMessageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(processedMessageCreateRequest)
  }
);}



export type getProcessedMessageResponse200 = {
  data: ProcessedMessageResponse
  status: 200
}

export type getProcessedMessageResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getProcessedMessageResponseSuccess = (getProcessedMessageResponse200) & {
  headers: Headers;
};
export type getProcessedMessageResponseError = (getProcessedMessageResponse422) & {
  headers: Headers;
};

export type getProcessedMessageResponse = (getProcessedMessageResponseSuccess | getProcessedMessageResponseError)

export const getGetProcessedMessageUrl = (messageId: string,) => {




  return `/api/v1/integrations/google/messages/${messageId}`
}

/**
 * Check if a message was already processed.
 * @summary Get Processed Message
 */
export const getProcessedMessage = async (messageId: string, options?: Parameters<typeof customFetch>[1]): Promise<getProcessedMessageResponse> => {

  return customFetch<getProcessedMessageResponse>(getGetProcessedMessageUrl(messageId),
  {
    ...options,
    method: 'GET'


  }
);}



export type checkSenderWhitelistResponse200 = {
  data: WhitelistCheckResponse
  status: 200
}

export type checkSenderWhitelistResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type checkSenderWhitelistResponseSuccess = (checkSenderWhitelistResponse200) & {
  headers: Headers;
};
export type checkSenderWhitelistResponseError = (checkSenderWhitelistResponse422) & {
  headers: Headers;
};

export type checkSenderWhitelistResponse = (checkSenderWhitelistResponseSuccess | checkSenderWhitelistResponseError)

export const getCheckSenderWhitelistUrl = (params: CheckSenderWhitelistParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/integrations/google/whitelist/check?${stringifiedParams}` : `/api/v1/integrations/google/whitelist/check`
}

/**
 * Check if a sender email is allowed by the whitelist for a user/org.
 * @summary Check Sender Whitelist
 */
export const checkSenderWhitelist = async (params: CheckSenderWhitelistParams, options?: Parameters<typeof customFetch>[1]): Promise<checkSenderWhitelistResponse> => {

  return customFetch<checkSenderWhitelistResponse>(getCheckSenderWhitelistUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type upsertXeroIntegrationResponse200 = {
  data: XeroIntegrationResponse
  status: 200
}

export type upsertXeroIntegrationResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type upsertXeroIntegrationResponseSuccess = (upsertXeroIntegrationResponse200) & {
  headers: Headers;
};
export type upsertXeroIntegrationResponseError = (upsertXeroIntegrationResponse422) & {
  headers: Headers;
};

export type upsertXeroIntegrationResponse = (upsertXeroIntegrationResponseSuccess | upsertXeroIntegrationResponseError)

export const getUpsertXeroIntegrationUrl = () => {




  return `/api/v1/integrations/xero`
}

/**
 * Persist or update Xero OAuth integration credentials for an organization and tenant.
 * Requires Service Account or Tenant Admin Bearer token.
 * @summary Upsert Xero Integration
 */
export const upsertXeroIntegration = async (xeroIntegrationUpsertRequest: XeroIntegrationUpsertRequest, options?: Parameters<typeof customFetch>[1]): Promise<upsertXeroIntegrationResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<upsertXeroIntegrationResponse>(getUpsertXeroIntegrationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(xeroIntegrationUpsertRequest)
  }
);}



export type getXeroIntegrationResponse200 = {
  data: XeroIntegrationDetailResponse
  status: 200
}

export type getXeroIntegrationResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getXeroIntegrationResponseSuccess = (getXeroIntegrationResponse200) & {
  headers: Headers;
};
export type getXeroIntegrationResponseError = (getXeroIntegrationResponse422) & {
  headers: Headers;
};

export type getXeroIntegrationResponse = (getXeroIntegrationResponseSuccess | getXeroIntegrationResponseError)

export const getGetXeroIntegrationUrl = (params?: GetXeroIntegrationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/integrations/xero?${stringifiedParams}` : `/api/v1/integrations/xero`
}

/**
 * Retrieve active Xero integration credentials and tenant metadata for the caller's organization.
 * @summary Get Xero Integration
 */
export const getXeroIntegration = async (params?: GetXeroIntegrationParams, options?: Parameters<typeof customFetch>[1]): Promise<getXeroIntegrationResponse> => {

  return customFetch<getXeroIntegrationResponse>(getGetXeroIntegrationUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type testSuitesListTestSuitesResponse200 = {
  data: TestSuiteListResponse
  status: 200
}

export type testSuitesListTestSuitesResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type testSuitesListTestSuitesResponseSuccess = (testSuitesListTestSuitesResponse200) & {
  headers: Headers;
};
export type testSuitesListTestSuitesResponseError = (testSuitesListTestSuitesResponse422) & {
  headers: Headers;
};

export type testSuitesListTestSuitesResponse = (testSuitesListTestSuitesResponseSuccess | testSuitesListTestSuitesResponseError)

export const getTestSuitesListTestSuitesUrl = (params?: TestSuitesListTestSuitesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/test-suites?${stringifiedParams}` : `/api/v1/test-suites`
}

/**
 * List all test suites for the current organization with total case counts.
 * @summary List Test Suites
 */
export const testSuitesListTestSuites = async (params?: TestSuitesListTestSuitesParams, options?: Parameters<typeof customFetch>[1]): Promise<testSuitesListTestSuitesResponse> => {

  return customFetch<testSuitesListTestSuitesResponse>(getTestSuitesListTestSuitesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type testSuitesCreateTestSuiteResponse201 = {
  data: TestSuiteSummaryResponse
  status: 201
}

export type testSuitesCreateTestSuiteResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type testSuitesCreateTestSuiteResponseSuccess = (testSuitesCreateTestSuiteResponse201) & {
  headers: Headers;
};
export type testSuitesCreateTestSuiteResponseError = (testSuitesCreateTestSuiteResponse422) & {
  headers: Headers;
};

export type testSuitesCreateTestSuiteResponse = (testSuitesCreateTestSuiteResponseSuccess | testSuitesCreateTestSuiteResponseError)

export const getTestSuitesCreateTestSuiteUrl = () => {




  return `/api/v1/test-suites`
}

/**
 * Create a new test suite.
 * @summary Create Test Suite
 */
export const testSuitesCreateTestSuite = async (testSuiteCreateRequest: TestSuiteCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<testSuitesCreateTestSuiteResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<testSuitesCreateTestSuiteResponse>(getTestSuitesCreateTestSuiteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(testSuiteCreateRequest)
  }
);}



export type testSuitesGetTestSuiteResponse200 = {
  data: TestSuiteDetailResponse
  status: 200
}

export type testSuitesGetTestSuiteResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type testSuitesGetTestSuiteResponseSuccess = (testSuitesGetTestSuiteResponse200) & {
  headers: Headers;
};
export type testSuitesGetTestSuiteResponseError = (testSuitesGetTestSuiteResponse422) & {
  headers: Headers;
};

export type testSuitesGetTestSuiteResponse = (testSuitesGetTestSuiteResponseSuccess | testSuitesGetTestSuiteResponseError)

export const getTestSuitesGetTestSuiteUrl = (suiteId: string,) => {




  return `/api/v1/test-suites/${suiteId}`
}

/**
 * Retrieve test suite details including all test cases.
 * @summary Get Test Suite
 */
export const testSuitesGetTestSuite = async (suiteId: string, options?: Parameters<typeof customFetch>[1]): Promise<testSuitesGetTestSuiteResponse> => {

  return customFetch<testSuitesGetTestSuiteResponse>(getTestSuitesGetTestSuiteUrl(suiteId),
  {
    ...options,
    method: 'GET'


  }
);}



export type testSuitesUpdateTestSuiteResponse200 = {
  data: TestSuiteSummaryResponse
  status: 200
}

export type testSuitesUpdateTestSuiteResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type testSuitesUpdateTestSuiteResponseSuccess = (testSuitesUpdateTestSuiteResponse200) & {
  headers: Headers;
};
export type testSuitesUpdateTestSuiteResponseError = (testSuitesUpdateTestSuiteResponse422) & {
  headers: Headers;
};

export type testSuitesUpdateTestSuiteResponse = (testSuitesUpdateTestSuiteResponseSuccess | testSuitesUpdateTestSuiteResponseError)

export const getTestSuitesUpdateTestSuiteUrl = (suiteId: string,) => {




  return `/api/v1/test-suites/${suiteId}`
}

/**
 * Update test suite metadata.
 * @summary Update Test Suite
 */
export const testSuitesUpdateTestSuite = async (suiteId: string,
    testSuiteUpdateRequest: TestSuiteUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<testSuitesUpdateTestSuiteResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<testSuitesUpdateTestSuiteResponse>(getTestSuitesUpdateTestSuiteUrl(suiteId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(testSuiteUpdateRequest)
  }
);}



export type testSuitesDeleteTestSuiteResponse204 = {
  data: void
  status: 204
}

export type testSuitesDeleteTestSuiteResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type testSuitesDeleteTestSuiteResponseSuccess = (testSuitesDeleteTestSuiteResponse204) & {
  headers: Headers;
};
export type testSuitesDeleteTestSuiteResponseError = (testSuitesDeleteTestSuiteResponse422) & {
  headers: Headers;
};

export type testSuitesDeleteTestSuiteResponse = (testSuitesDeleteTestSuiteResponseSuccess | testSuitesDeleteTestSuiteResponseError)

export const getTestSuitesDeleteTestSuiteUrl = (suiteId: string,) => {




  return `/api/v1/test-suites/${suiteId}`
}

/**
 * Delete a test suite and its test cases.
 * @summary Delete Test Suite
 */
export const testSuitesDeleteTestSuite = async (suiteId: string, options?: Parameters<typeof customFetch>[1]): Promise<testSuitesDeleteTestSuiteResponse> => {

  return customFetch<testSuitesDeleteTestSuiteResponse>(getTestSuitesDeleteTestSuiteUrl(suiteId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type testSuitesCloneTestSuiteResponse201 = {
  data: TestSuiteDetailResponse
  status: 201
}

export type testSuitesCloneTestSuiteResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type testSuitesCloneTestSuiteResponseSuccess = (testSuitesCloneTestSuiteResponse201) & {
  headers: Headers;
};
export type testSuitesCloneTestSuiteResponseError = (testSuitesCloneTestSuiteResponse422) & {
  headers: Headers;
};

export type testSuitesCloneTestSuiteResponse = (testSuitesCloneTestSuiteResponseSuccess | testSuitesCloneTestSuiteResponseError)

export const getTestSuitesCloneTestSuiteUrl = (suiteId: string,) => {




  return `/api/v1/test-suites/${suiteId}/clone`
}

/**
 * Clone a test suite and all of its test cases.
 * @summary Clone Test Suite
 */
export const testSuitesCloneTestSuite = async (suiteId: string,
    testSuiteCloneRequest: TestSuiteCloneRequest, options?: Parameters<typeof customFetch>[1]): Promise<testSuitesCloneTestSuiteResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<testSuitesCloneTestSuiteResponse>(getTestSuitesCloneTestSuiteUrl(suiteId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(testSuiteCloneRequest)
  }
);}



export type testSuitesImportTestSuiteResponse201 = {
  data: TestSuiteDetailResponse
  status: 201
}

export type testSuitesImportTestSuiteResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type testSuitesImportTestSuiteResponseSuccess = (testSuitesImportTestSuiteResponse201) & {
  headers: Headers;
};
export type testSuitesImportTestSuiteResponseError = (testSuitesImportTestSuiteResponse422) & {
  headers: Headers;
};

export type testSuitesImportTestSuiteResponse = (testSuitesImportTestSuiteResponseSuccess | testSuitesImportTestSuiteResponseError)

export const getTestSuitesImportTestSuiteUrl = () => {




  return `/api/v1/test-suites/import`
}

/**
 * Import an entire test suite with test cases in a single payload.
 * @summary Import Test Suite
 */
export const testSuitesImportTestSuite = async (testSuiteImportRequest: TestSuiteImportRequest, options?: Parameters<typeof customFetch>[1]): Promise<testSuitesImportTestSuiteResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<testSuitesImportTestSuiteResponse>(getTestSuitesImportTestSuiteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(testSuiteImportRequest)
  }
);}



export type testSuitesArchiveTestSuiteResponse200 = {
  data: TestSuiteSummaryResponse
  status: 200
}

export type testSuitesArchiveTestSuiteResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type testSuitesArchiveTestSuiteResponseSuccess = (testSuitesArchiveTestSuiteResponse200) & {
  headers: Headers;
};
export type testSuitesArchiveTestSuiteResponseError = (testSuitesArchiveTestSuiteResponse422) & {
  headers: Headers;
};

export type testSuitesArchiveTestSuiteResponse = (testSuitesArchiveTestSuiteResponseSuccess | testSuitesArchiveTestSuiteResponseError)

export const getTestSuitesArchiveTestSuiteUrl = (suiteId: string,) => {




  return `/api/v1/test-suites/${suiteId}/archive`
}

/**
 * Archive a test suite.
 * @summary Archive Test Suite
 */
export const testSuitesArchiveTestSuite = async (suiteId: string, options?: Parameters<typeof customFetch>[1]): Promise<testSuitesArchiveTestSuiteResponse> => {

  return customFetch<testSuitesArchiveTestSuiteResponse>(getTestSuitesArchiveTestSuiteUrl(suiteId),
  {
    ...options,
    method: 'POST'


  }
);}



export type testSuitesUnarchiveTestSuiteResponse200 = {
  data: TestSuiteSummaryResponse
  status: 200
}

export type testSuitesUnarchiveTestSuiteResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type testSuitesUnarchiveTestSuiteResponseSuccess = (testSuitesUnarchiveTestSuiteResponse200) & {
  headers: Headers;
};
export type testSuitesUnarchiveTestSuiteResponseError = (testSuitesUnarchiveTestSuiteResponse422) & {
  headers: Headers;
};

export type testSuitesUnarchiveTestSuiteResponse = (testSuitesUnarchiveTestSuiteResponseSuccess | testSuitesUnarchiveTestSuiteResponseError)

export const getTestSuitesUnarchiveTestSuiteUrl = (suiteId: string,) => {




  return `/api/v1/test-suites/${suiteId}/unarchive`
}

/**
 * Unarchive a test suite.
 * @summary Unarchive Test Suite
 */
export const testSuitesUnarchiveTestSuite = async (suiteId: string, options?: Parameters<typeof customFetch>[1]): Promise<testSuitesUnarchiveTestSuiteResponse> => {

  return customFetch<testSuitesUnarchiveTestSuiteResponse>(getTestSuitesUnarchiveTestSuiteUrl(suiteId),
  {
    ...options,
    method: 'POST'


  }
);}



export type testSuitesCreateTestCaseResponse201 = {
  data: TestCaseResponse
  status: 201
}

export type testSuitesCreateTestCaseResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type testSuitesCreateTestCaseResponseSuccess = (testSuitesCreateTestCaseResponse201) & {
  headers: Headers;
};
export type testSuitesCreateTestCaseResponseError = (testSuitesCreateTestCaseResponse422) & {
  headers: Headers;
};

export type testSuitesCreateTestCaseResponse = (testSuitesCreateTestCaseResponseSuccess | testSuitesCreateTestCaseResponseError)

export const getTestSuitesCreateTestCaseUrl = (suiteId: string,) => {




  return `/api/v1/test-suites/${suiteId}/cases`
}

/**
 * Add a test case to a test suite.
 * @summary Create Test Case
 */
export const testSuitesCreateTestCase = async (suiteId: string,
    testCaseCreateRequest: TestCaseCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<testSuitesCreateTestCaseResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<testSuitesCreateTestCaseResponse>(getTestSuitesCreateTestCaseUrl(suiteId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(testCaseCreateRequest)
  }
);}



export type testSuitesGetTestCaseResponse200 = {
  data: TestCaseResponse
  status: 200
}

export type testSuitesGetTestCaseResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type testSuitesGetTestCaseResponseSuccess = (testSuitesGetTestCaseResponse200) & {
  headers: Headers;
};
export type testSuitesGetTestCaseResponseError = (testSuitesGetTestCaseResponse422) & {
  headers: Headers;
};

export type testSuitesGetTestCaseResponse = (testSuitesGetTestCaseResponseSuccess | testSuitesGetTestCaseResponseError)

export const getTestSuitesGetTestCaseUrl = (suiteId: string,
    caseId: string,) => {




  return `/api/v1/test-suites/${suiteId}/cases/${caseId}`
}

/**
 * Retrieve a specific test case within a suite.
 * @summary Get Test Case
 */
export const testSuitesGetTestCase = async (suiteId: string,
    caseId: string, options?: Parameters<typeof customFetch>[1]): Promise<testSuitesGetTestCaseResponse> => {

  return customFetch<testSuitesGetTestCaseResponse>(getTestSuitesGetTestCaseUrl(suiteId,caseId),
  {
    ...options,
    method: 'GET'


  }
);}



export type testSuitesUpdateTestCaseResponse200 = {
  data: TestCaseResponse
  status: 200
}

export type testSuitesUpdateTestCaseResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type testSuitesUpdateTestCaseResponseSuccess = (testSuitesUpdateTestCaseResponse200) & {
  headers: Headers;
};
export type testSuitesUpdateTestCaseResponseError = (testSuitesUpdateTestCaseResponse422) & {
  headers: Headers;
};

export type testSuitesUpdateTestCaseResponse = (testSuitesUpdateTestCaseResponseSuccess | testSuitesUpdateTestCaseResponseError)

export const getTestSuitesUpdateTestCaseUrl = (suiteId: string,
    caseId: string,) => {




  return `/api/v1/test-suites/${suiteId}/cases/${caseId}`
}

/**
 * Update a test case.
 * @summary Update Test Case
 */
export const testSuitesUpdateTestCase = async (suiteId: string,
    caseId: string,
    testCaseUpdateRequest: TestCaseUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<testSuitesUpdateTestCaseResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<testSuitesUpdateTestCaseResponse>(getTestSuitesUpdateTestCaseUrl(suiteId,caseId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(testCaseUpdateRequest)
  }
);}



export type testSuitesDeleteTestCaseResponse204 = {
  data: void
  status: 204
}

export type testSuitesDeleteTestCaseResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type testSuitesDeleteTestCaseResponseSuccess = (testSuitesDeleteTestCaseResponse204) & {
  headers: Headers;
};
export type testSuitesDeleteTestCaseResponseError = (testSuitesDeleteTestCaseResponse422) & {
  headers: Headers;
};

export type testSuitesDeleteTestCaseResponse = (testSuitesDeleteTestCaseResponseSuccess | testSuitesDeleteTestCaseResponseError)

export const getTestSuitesDeleteTestCaseUrl = (suiteId: string,
    caseId: string,) => {




  return `/api/v1/test-suites/${suiteId}/cases/${caseId}`
}

/**
 * Delete a test case from a suite.
 * @summary Delete Test Case
 */
export const testSuitesDeleteTestCase = async (suiteId: string,
    caseId: string, options?: Parameters<typeof customFetch>[1]): Promise<testSuitesDeleteTestCaseResponse> => {

  return customFetch<testSuitesDeleteTestCaseResponse>(getTestSuitesDeleteTestCaseUrl(suiteId,caseId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type testSuitesSuggestTestCaseTurnResponse200 = {
  data: TestCaseSuggestResponse
  status: 200
}

export type testSuitesSuggestTestCaseTurnResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type testSuitesSuggestTestCaseTurnResponseSuccess = (testSuitesSuggestTestCaseTurnResponse200) & {
  headers: Headers;
};
export type testSuitesSuggestTestCaseTurnResponseError = (testSuitesSuggestTestCaseTurnResponse422) & {
  headers: Headers;
};

export type testSuitesSuggestTestCaseTurnResponse = (testSuitesSuggestTestCaseTurnResponseSuccess | testSuitesSuggestTestCaseTurnResponseError)

export const getTestSuitesSuggestTestCaseTurnUrl = (suiteId: string,) => {




  return `/api/v1/test-suites/${suiteId}/cases/suggest-turn`
}

/**
 * Synchronously generate an auto-suggested assistant response for a test case scenario.
 * Queries the target agent via AI Gateway using real tools, prompts, and active rules.
 * @summary Suggest Test Case Turn
 */
export const testSuitesSuggestTestCaseTurn = async (suiteId: string,
    testCaseSuggestRequest: TestCaseSuggestRequest, options?: Parameters<typeof customFetch>[1]): Promise<testSuitesSuggestTestCaseTurnResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<testSuitesSuggestTestCaseTurnResponse>(getTestSuitesSuggestTestCaseTurnUrl(suiteId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(testCaseSuggestRequest)
  }
);}



export type testSuitesSuggestTestCaseTitleResponse200 = {
  data: TestCaseSuggestTitleResponse
  status: 200
}

export type testSuitesSuggestTestCaseTitleResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type testSuitesSuggestTestCaseTitleResponseSuccess = (testSuitesSuggestTestCaseTitleResponse200) & {
  headers: Headers;
};
export type testSuitesSuggestTestCaseTitleResponseError = (testSuitesSuggestTestCaseTitleResponse422) & {
  headers: Headers;
};

export type testSuitesSuggestTestCaseTitleResponse = (testSuitesSuggestTestCaseTitleResponseSuccess | testSuitesSuggestTestCaseTitleResponseError)

export const getTestSuitesSuggestTestCaseTitleUrl = (suiteId: string,) => {




  return `/api/v1/test-suites/${suiteId}/cases/suggest-title`
}

/**
 * Synchronously generate an auto-suggested test case title from scenario turns.
 * Calls AI Gateway to generate a concise, descriptive title via LLM.
 * @summary Suggest Test Case Title
 */
export const testSuitesSuggestTestCaseTitle = async (suiteId: string,
    testCaseSuggestTitleRequest: TestCaseSuggestTitleRequest, options?: Parameters<typeof customFetch>[1]): Promise<testSuitesSuggestTestCaseTitleResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<testSuitesSuggestTestCaseTitleResponse>(getTestSuitesSuggestTestCaseTitleUrl(suiteId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(testCaseSuggestTitleRequest)
  }
);}



export type testRunsCreateTestRunResponse201 = {
  data: TestRunResponse
  status: 201
}

export type testRunsCreateTestRunResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type testRunsCreateTestRunResponseSuccess = (testRunsCreateTestRunResponse201) & {
  headers: Headers;
};
export type testRunsCreateTestRunResponseError = (testRunsCreateTestRunResponse422) & {
  headers: Headers;
};

export type testRunsCreateTestRunResponse = (testRunsCreateTestRunResponseSuccess | testRunsCreateTestRunResponseError)

export const getTestRunsCreateTestRunUrl = () => {




  return `/api/v1/test-runs`
}

/**
 * Trigger execution of a test run pairing a test suite with an environment snapshot.
 * @summary Create Test Run
 */
export const testRunsCreateTestRun = async (testRunCreateRequest: TestRunCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<testRunsCreateTestRunResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<testRunsCreateTestRunResponse>(getTestRunsCreateTestRunUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(testRunCreateRequest)
  }
);}



export type testRunsListTestRunsResponse200 = {
  data: TestRunListResponse
  status: 200
}

export type testRunsListTestRunsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type testRunsListTestRunsResponseSuccess = (testRunsListTestRunsResponse200) & {
  headers: Headers;
};
export type testRunsListTestRunsResponseError = (testRunsListTestRunsResponse422) & {
  headers: Headers;
};

export type testRunsListTestRunsResponse = (testRunsListTestRunsResponseSuccess | testRunsListTestRunsResponseError)

export const getTestRunsListTestRunsUrl = (params?: TestRunsListTestRunsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/test-runs?${stringifiedParams}` : `/api/v1/test-runs`
}

/**
 * List test execution runs with pagination and optional suite filtering.
 * @summary List Test Runs
 */
export const testRunsListTestRuns = async (params?: TestRunsListTestRunsParams, options?: Parameters<typeof customFetch>[1]): Promise<testRunsListTestRunsResponse> => {

  return customFetch<testRunsListTestRunsResponse>(getTestRunsListTestRunsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type testRunsExecuteTestRunEndpointResponse200 = {
  data: unknown
  status: 200
}

export type testRunsExecuteTestRunEndpointResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type testRunsExecuteTestRunEndpointResponseSuccess = (testRunsExecuteTestRunEndpointResponse200) & {
  headers: Headers;
};
export type testRunsExecuteTestRunEndpointResponseError = (testRunsExecuteTestRunEndpointResponse422) & {
  headers: Headers;
};

export type testRunsExecuteTestRunEndpointResponse = (testRunsExecuteTestRunEndpointResponseSuccess | testRunsExecuteTestRunEndpointResponseError)

export const getTestRunsExecuteTestRunEndpointUrl = (runId: string,) => {




  return `/api/v1/test-runs/${runId}/execute`
}

/**
 * Executes a test run directly and synchronously updates its state and metrics.
 * @summary Execute Test Run Endpoint
 */
export const testRunsExecuteTestRunEndpoint = async (runId: string, options?: Parameters<typeof customFetch>[1]): Promise<testRunsExecuteTestRunEndpointResponse> => {

  return customFetch<testRunsExecuteTestRunEndpointResponse>(getTestRunsExecuteTestRunEndpointUrl(runId),
  {
    ...options,
    method: 'POST'


  }
);}



export type testRunsCompareTestRunsResponse200 = {
  data: TestRunComparisonResponse
  status: 200
}

export type testRunsCompareTestRunsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type testRunsCompareTestRunsResponseSuccess = (testRunsCompareTestRunsResponse200) & {
  headers: Headers;
};
export type testRunsCompareTestRunsResponseError = (testRunsCompareTestRunsResponse422) & {
  headers: Headers;
};

export type testRunsCompareTestRunsResponse = (testRunsCompareTestRunsResponseSuccess | testRunsCompareTestRunsResponseError)

export const getTestRunsCompareTestRunsUrl = (params: TestRunsCompareTestRunsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/test-runs/compare?${stringifiedParams}` : `/api/v1/test-runs/compare`
}

/**
 * Compares Run A (Baseline) and Run B (Candidate) across case-level message dialogue outputs.
 * @summary Compare Test Runs
 */
export const testRunsCompareTestRuns = async (params: TestRunsCompareTestRunsParams, options?: Parameters<typeof customFetch>[1]): Promise<testRunsCompareTestRunsResponse> => {

  return customFetch<testRunsCompareTestRunsResponse>(getTestRunsCompareTestRunsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type testRunsGetTestRunResponse200 = {
  data: TestRunResponse
  status: 200
}

export type testRunsGetTestRunResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type testRunsGetTestRunResponseSuccess = (testRunsGetTestRunResponse200) & {
  headers: Headers;
};
export type testRunsGetTestRunResponseError = (testRunsGetTestRunResponse422) & {
  headers: Headers;
};

export type testRunsGetTestRunResponse = (testRunsGetTestRunResponseSuccess | testRunsGetTestRunResponseError)

export const getTestRunsGetTestRunUrl = (runId: string,) => {




  return `/api/v1/test-runs/${runId}`
}

/**
 * Retrieve test run status, metrics, and side-by-side case results.
 * @summary Get Test Run
 */
export const testRunsGetTestRun = async (runId: string, options?: Parameters<typeof customFetch>[1]): Promise<testRunsGetTestRunResponse> => {

  return customFetch<testRunsGetTestRunResponse>(getTestRunsGetTestRunUrl(runId),
  {
    ...options,
    method: 'GET'


  }
);}



export type testRunsUpdateTestRunResponse200 = {
  data: TestRunResponse
  status: 200
}

export type testRunsUpdateTestRunResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type testRunsUpdateTestRunResponseSuccess = (testRunsUpdateTestRunResponse200) & {
  headers: Headers;
};
export type testRunsUpdateTestRunResponseError = (testRunsUpdateTestRunResponse422) & {
  headers: Headers;
};

export type testRunsUpdateTestRunResponse = (testRunsUpdateTestRunResponseSuccess | testRunsUpdateTestRunResponseError)

export const getTestRunsUpdateTestRunUrl = (runId: string,) => {




  return `/api/v1/test-runs/${runId}`
}

/**
 * Updates test run status, progress, batch link, or summary metrics.
 * @summary Update Test Run
 */
export const testRunsUpdateTestRun = async (runId: string,
    testRunUpdateRequest: TestRunUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<testRunsUpdateTestRunResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<testRunsUpdateTestRunResponse>(getTestRunsUpdateTestRunUrl(runId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(testRunUpdateRequest)
  }
);}



export type testRunsDeleteTestRunResponse200 = {
  data: TestRunResponse
  status: 200
}

export type testRunsDeleteTestRunResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type testRunsDeleteTestRunResponseSuccess = (testRunsDeleteTestRunResponse200) & {
  headers: Headers;
};
export type testRunsDeleteTestRunResponseError = (testRunsDeleteTestRunResponse422) & {
  headers: Headers;
};

export type testRunsDeleteTestRunResponse = (testRunsDeleteTestRunResponseSuccess | testRunsDeleteTestRunResponseError)

export const getTestRunsDeleteTestRunUrl = (runId: string,) => {




  return `/api/v1/test-runs/${runId}`
}

/**
 * Soft-delete / archive a test run.
 * @summary Delete Test Run
 */
export const testRunsDeleteTestRun = async (runId: string, options?: Parameters<typeof customFetch>[1]): Promise<testRunsDeleteTestRunResponse> => {

  return customFetch<testRunsDeleteTestRunResponse>(getTestRunsDeleteTestRunUrl(runId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type testRunsCancelTestRunResponse200 = {
  data: TestRunResponse
  status: 200
}

export type testRunsCancelTestRunResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type testRunsCancelTestRunResponseSuccess = (testRunsCancelTestRunResponse200) & {
  headers: Headers;
};
export type testRunsCancelTestRunResponseError = (testRunsCancelTestRunResponse422) & {
  headers: Headers;
};

export type testRunsCancelTestRunResponse = (testRunsCancelTestRunResponseSuccess | testRunsCancelTestRunResponseError)

export const getTestRunsCancelTestRunUrl = (runId: string,) => {




  return `/api/v1/test-runs/${runId}/cancel`
}

/**
 * Cancel an active or pending test run.
 * @summary Cancel Test Run
 */
export const testRunsCancelTestRun = async (runId: string, options?: Parameters<typeof customFetch>[1]): Promise<testRunsCancelTestRunResponse> => {

  return customFetch<testRunsCancelTestRunResponse>(getTestRunsCancelTestRunUrl(runId),
  {
    ...options,
    method: 'POST'


  }
);}



export type testRunsArchiveTestRunResponse200 = {
  data: TestRunResponse
  status: 200
}

export type testRunsArchiveTestRunResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type testRunsArchiveTestRunResponseSuccess = (testRunsArchiveTestRunResponse200) & {
  headers: Headers;
};
export type testRunsArchiveTestRunResponseError = (testRunsArchiveTestRunResponse422) & {
  headers: Headers;
};

export type testRunsArchiveTestRunResponse = (testRunsArchiveTestRunResponseSuccess | testRunsArchiveTestRunResponseError)

export const getTestRunsArchiveTestRunUrl = (runId: string,) => {




  return `/api/v1/test-runs/${runId}/archive`
}

/**
 * Archive a test run.
 * @summary Archive Test Run
 */
export const testRunsArchiveTestRun = async (runId: string, options?: Parameters<typeof customFetch>[1]): Promise<testRunsArchiveTestRunResponse> => {

  return customFetch<testRunsArchiveTestRunResponse>(getTestRunsArchiveTestRunUrl(runId),
  {
    ...options,
    method: 'POST'


  }
);}



export type testRunsUnarchiveTestRunResponse200 = {
  data: TestRunResponse
  status: 200
}

export type testRunsUnarchiveTestRunResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type testRunsUnarchiveTestRunResponseSuccess = (testRunsUnarchiveTestRunResponse200) & {
  headers: Headers;
};
export type testRunsUnarchiveTestRunResponseError = (testRunsUnarchiveTestRunResponse422) & {
  headers: Headers;
};

export type testRunsUnarchiveTestRunResponse = (testRunsUnarchiveTestRunResponseSuccess | testRunsUnarchiveTestRunResponseError)

export const getTestRunsUnarchiveTestRunUrl = (runId: string,) => {




  return `/api/v1/test-runs/${runId}/unarchive`
}

/**
 * Unarchive a test run.
 * @summary Unarchive Test Run
 */
export const testRunsUnarchiveTestRun = async (runId: string, options?: Parameters<typeof customFetch>[1]): Promise<testRunsUnarchiveTestRunResponse> => {

  return customFetch<testRunsUnarchiveTestRunResponse>(getTestRunsUnarchiveTestRunUrl(runId),
  {
    ...options,
    method: 'POST'


  }
);}



export type environmentSnapshotsListEnvironmentSnapshotsResponse200 = {
  data: SnapshotListResponse
  status: 200
}

export type environmentSnapshotsListEnvironmentSnapshotsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type environmentSnapshotsListEnvironmentSnapshotsResponseSuccess = (environmentSnapshotsListEnvironmentSnapshotsResponse200) & {
  headers: Headers;
};
export type environmentSnapshotsListEnvironmentSnapshotsResponseError = (environmentSnapshotsListEnvironmentSnapshotsResponse422) & {
  headers: Headers;
};

export type environmentSnapshotsListEnvironmentSnapshotsResponse = (environmentSnapshotsListEnvironmentSnapshotsResponseSuccess | environmentSnapshotsListEnvironmentSnapshotsResponseError)

export const getEnvironmentSnapshotsListEnvironmentSnapshotsUrl = (params?: EnvironmentSnapshotsListEnvironmentSnapshotsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/environment-snapshots?${stringifiedParams}` : `/api/v1/environment-snapshots`
}

/**
 * List frozen environment snapshots for the organization.
 * @summary List Environment Snapshots
 */
export const environmentSnapshotsListEnvironmentSnapshots = async (params?: EnvironmentSnapshotsListEnvironmentSnapshotsParams, options?: Parameters<typeof customFetch>[1]): Promise<environmentSnapshotsListEnvironmentSnapshotsResponse> => {

  return customFetch<environmentSnapshotsListEnvironmentSnapshotsResponse>(getEnvironmentSnapshotsListEnvironmentSnapshotsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type environmentSnapshotsCreateSnapshotResponse201 = {
  data: SnapshotResponse
  status: 201
}

export type environmentSnapshotsCreateSnapshotResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type environmentSnapshotsCreateSnapshotResponseSuccess = (environmentSnapshotsCreateSnapshotResponse201) & {
  headers: Headers;
};
export type environmentSnapshotsCreateSnapshotResponseError = (environmentSnapshotsCreateSnapshotResponse422) & {
  headers: Headers;
};

export type environmentSnapshotsCreateSnapshotResponse = (environmentSnapshotsCreateSnapshotResponseSuccess | environmentSnapshotsCreateSnapshotResponseError)

export const getEnvironmentSnapshotsCreateSnapshotUrl = () => {




  return `/api/v1/environment-snapshots`
}

/**
 * Create an immutable environment snapshot freezing active versions or specified version sets.
 * @summary Create Snapshot
 */
export const environmentSnapshotsCreateSnapshot = async (snapshotCreateRequest: SnapshotCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<environmentSnapshotsCreateSnapshotResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<environmentSnapshotsCreateSnapshotResponse>(getEnvironmentSnapshotsCreateSnapshotUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(snapshotCreateRequest)
  }
);}



export type environmentSnapshotsGetEnvironmentSnapshotResponse200 = {
  data: SnapshotResponse
  status: 200
}

export type environmentSnapshotsGetEnvironmentSnapshotResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type environmentSnapshotsGetEnvironmentSnapshotResponseSuccess = (environmentSnapshotsGetEnvironmentSnapshotResponse200) & {
  headers: Headers;
};
export type environmentSnapshotsGetEnvironmentSnapshotResponseError = (environmentSnapshotsGetEnvironmentSnapshotResponse422) & {
  headers: Headers;
};

export type environmentSnapshotsGetEnvironmentSnapshotResponse = (environmentSnapshotsGetEnvironmentSnapshotResponseSuccess | environmentSnapshotsGetEnvironmentSnapshotResponseError)

export const getEnvironmentSnapshotsGetEnvironmentSnapshotUrl = (snapshotId: string,) => {




  return `/api/v1/environment-snapshots/${snapshotId}`
}

/**
 * Retrieve snapshot details.
 * @summary Get Environment Snapshot
 */
export const environmentSnapshotsGetEnvironmentSnapshot = async (snapshotId: string, options?: Parameters<typeof customFetch>[1]): Promise<environmentSnapshotsGetEnvironmentSnapshotResponse> => {

  return customFetch<environmentSnapshotsGetEnvironmentSnapshotResponse>(getEnvironmentSnapshotsGetEnvironmentSnapshotUrl(snapshotId),
  {
    ...options,
    method: 'GET'


  }
);}



export type environmentSnapshotsArchiveEnvironmentSnapshotResponse200 = {
  data: SnapshotResponse
  status: 200
}

export type environmentSnapshotsArchiveEnvironmentSnapshotResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type environmentSnapshotsArchiveEnvironmentSnapshotResponseSuccess = (environmentSnapshotsArchiveEnvironmentSnapshotResponse200) & {
  headers: Headers;
};
export type environmentSnapshotsArchiveEnvironmentSnapshotResponseError = (environmentSnapshotsArchiveEnvironmentSnapshotResponse422) & {
  headers: Headers;
};

export type environmentSnapshotsArchiveEnvironmentSnapshotResponse = (environmentSnapshotsArchiveEnvironmentSnapshotResponseSuccess | environmentSnapshotsArchiveEnvironmentSnapshotResponseError)

export const getEnvironmentSnapshotsArchiveEnvironmentSnapshotUrl = (snapshotId: string,) => {




  return `/api/v1/environment-snapshots/${snapshotId}/archive`
}

/**
 * Archive an environment snapshot.
 * @summary Archive Environment Snapshot
 */
export const environmentSnapshotsArchiveEnvironmentSnapshot = async (snapshotId: string, options?: Parameters<typeof customFetch>[1]): Promise<environmentSnapshotsArchiveEnvironmentSnapshotResponse> => {

  return customFetch<environmentSnapshotsArchiveEnvironmentSnapshotResponse>(getEnvironmentSnapshotsArchiveEnvironmentSnapshotUrl(snapshotId),
  {
    ...options,
    method: 'POST'


  }
);}



export type environmentSnapshotsUnarchiveEnvironmentSnapshotResponse200 = {
  data: SnapshotResponse
  status: 200
}

export type environmentSnapshotsUnarchiveEnvironmentSnapshotResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type environmentSnapshotsUnarchiveEnvironmentSnapshotResponseSuccess = (environmentSnapshotsUnarchiveEnvironmentSnapshotResponse200) & {
  headers: Headers;
};
export type environmentSnapshotsUnarchiveEnvironmentSnapshotResponseError = (environmentSnapshotsUnarchiveEnvironmentSnapshotResponse422) & {
  headers: Headers;
};

export type environmentSnapshotsUnarchiveEnvironmentSnapshotResponse = (environmentSnapshotsUnarchiveEnvironmentSnapshotResponseSuccess | environmentSnapshotsUnarchiveEnvironmentSnapshotResponseError)

export const getEnvironmentSnapshotsUnarchiveEnvironmentSnapshotUrl = (snapshotId: string,) => {




  return `/api/v1/environment-snapshots/${snapshotId}/unarchive`
}

/**
 * Unarchive an environment snapshot.
 * @summary Unarchive Environment Snapshot
 */
export const environmentSnapshotsUnarchiveEnvironmentSnapshot = async (snapshotId: string, options?: Parameters<typeof customFetch>[1]): Promise<environmentSnapshotsUnarchiveEnvironmentSnapshotResponse> => {

  return customFetch<environmentSnapshotsUnarchiveEnvironmentSnapshotResponse>(getEnvironmentSnapshotsUnarchiveEnvironmentSnapshotUrl(snapshotId),
  {
    ...options,
    method: 'POST'


  }
);}



export type systemHealthzRootResponse200 = {
  data: HealthResponse
  status: 200
}

export type systemHealthzRootResponseSuccess = (systemHealthzRootResponse200) & {
  headers: Headers;
};
;

export type systemHealthzRootResponse = (systemHealthzRootResponseSuccess)

export const getSystemHealthzRootUrl = () => {




  return `/healthz`
}

/**
 * @summary Healthz Root
 */
export const systemHealthzRoot = async ( options?: Parameters<typeof customFetch>[1]): Promise<systemHealthzRootResponse> => {

  return customFetch<systemHealthzRootResponse>(getSystemHealthzRootUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type systemHealthzResponse200 = {
  data: HealthResponse
  status: 200
}

export type systemHealthzResponseSuccess = (systemHealthzResponse200) & {
  headers: Headers;
};
;

export type systemHealthzResponse = (systemHealthzResponseSuccess)

export const getSystemHealthzUrl = () => {




  return `/api/healthz`
}

/**
 * @summary Healthz
 */
export const systemHealthz = async ( options?: Parameters<typeof customFetch>[1]): Promise<systemHealthzResponse> => {

  return customFetch<systemHealthzResponse>(getSystemHealthzUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



